/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as Messages from './RebatePgmConstants';
import { v4 as uuidv4 } from 'uuid';
import {
  autoFormateDate,
  removeErr,
} from '../../../SharedModules/utilities/utilities';
import * as AppConstants from '../../../SharedModules/AppConstants';
import { validMMDDFormat } from '../../../SharedModules/DateUtilities/DateUtilities';
import _ from 'lodash';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import {
  checkQuarterValidation,
  compareQtrs,
  isOverlapQtr,
  convertQuaterToDate,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import axios from 'axios';
import * as serviceEndPoint from '../../../SharedModules/services/service';

export const detailsInvoiceOverrideTabsValidations = (
  pgmDetail,
  extraCondition = null
) => {
  const error = [];
  let flderror = {};

  if (!pgmDetail.shortDescr || pgmDetail.shortDescr === '') {
    error.push(Messages.SHORT_DESC_ERR);
    flderror = { ...flderror, shtDescErr: true };
  }

  if (!pgmDetail.longDescr || pgmDetail.longDescr === '') {
    error.push(Messages.LONG_DESC_ERR);
    flderror = { ...flderror, longDescErr: true };
  }

  if (!pgmDetail.rebateProgramCd || pgmDetail.rebateProgramCd === '') {
    error.push(Messages.REBETE_PGM_ERR);
    flderror = { ...flderror, rebatePgmErr: true };
  } else if (pgmDetail.rebateProgramCd !== '' && !extraCondition) {
    error.push(Messages.REBETE_PGM_INVALID_ERR);
    flderror = { ...flderror, rebatePgmInvalidErr: true };
  }

  if (
    !pgmDetail.checkPayeeCd ||
    pgmDetail.checkPayeeCd === '' ||
    pgmDetail.checkPayeeCd === '-1'
  ) {
    error.push(Messages.CHECK_PAY_ERR);
    flderror = { ...flderror, checkPayErr: true };
  }

  if (
    (!pgmDetail.cms64AgencyName && pgmDetail?.planTypeCd === 'FD') ||
    (pgmDetail.cms64AgencyName === '' && pgmDetail?.planTypeCd === 'FD')
  ) {
    error.push(Messages.CMS64_ERR);
    flderror = { ...flderror, cms64Err: true };
  }

  if (
    (!pgmDetail.stateAbbrev ||
      pgmDetail.stateAbbrev === '' ||
      pgmDetail.stateAbbrev === '-1') &&
    pgmDetail?.planTypeCd !== 'COMM'
  ) {
    error.push(Messages.STATE_ERR);
    flderror = { ...flderror, stateErr: true };
  }
  // case 'defEarliestQtrForDrugDtls':
  //   error = removeErr(err, [
  //     Messages.EARLIER_QTR_ERR,
  //     constantMessageData.VALIDATE_QUARTER_VALUE,
  //   ]);

  if (
    !pgmDetail.defEarliestQtrForDrugDtls ||
    pgmDetail.defEarliestQtrForDrugDtls === ''
  ) {
    error.push(Messages.EARLIER_QTR_ERR);
    flderror = { ...flderror, earlierQtrReqErr: true, earlierQtrQtrErr: false };
  } else if (
    pgmDetail.defEarliestQtrForDrugDtls &&
    pgmDetail.defEarliestQtrForDrugDtls !== '' &&
    !checkQuarterValidation(pgmDetail.defEarliestQtrForDrugDtls)
  ) {
    error.push(constantMessageData.VALIDATE_QUARTER_VALUE);
    flderror = { ...flderror, earlierQtrReqErr: false, earlierQtrQtrErr: true };
  }

  if (
    (pgmDetail.sendAllRetainedQtr &&
      pgmDetail.sendAllRetainedQtr !== '' &&
      AppConstants.NUMBER_REGEX.test(pgmDetail.sendAllRetainedQtr) === false) ||
    parseInt(pgmDetail.sendAllRetainedQtr, 10) < 0 ||
    parseInt(pgmDetail.sendAllRetainedQtr, 10) > 4
  ) {
    error.push(Messages.SEND_ALL_RETAINED_QTR);
    flderror = { ...flderror, sendAllRetainedQtrErr: true };
  }

  if (pgmDetail && pgmDetail.rptBalanceDueThreshold === '') {
    error.push(Messages.REPORT_BALANCE_DUE_REQ_ERR);
    flderror = { ...flderror, rptBalanceDueThresholdReqErr: true };
  }

  if (
    pgmDetail.rptBalanceDueThreshold &&
    pgmDetail.rptBalanceDueThreshold !== '' &&
    AppConstants.NUMBER_REGEX.test(pgmDetail.rptBalanceDueThreshold) === false
  ) {
    error.push(Messages.REPORT_BALANCE_DUE_ERR);
    flderror = { ...flderror, rptBalanceDueThresholdErr: true };
  }

  if (
    (pgmDetail.invoiceMailThreshold &&
      pgmDetail.invoiceMailThreshold !== '' &&
      isNaN(parseFloat(pgmDetail.invoiceMailThreshold))) ||
    parseInt(pgmDetail.invoiceMailThreshold, 10) > 50
  ) {
    error.push(Messages.INVOICE_MAIL_ERR);
    flderror = { ...flderror, invoiceMailThresholdErr: true };
  }

  if (
    pgmDetail.numOfDebitMfg &&
    pgmDetail.numOfDebitMfg !== '' &&
    AppConstants.NUMBER_REGEX.test(pgmDetail.numOfDebitMfg) === false
  ) {
    error.push(Messages.DEBIT_MANUFACTURERS_ERR);
    flderror = { ...flderror, numOfDebitMfgErr: true };
  }

  // case 'numOfCreditMfg':
  if (
    pgmDetail.numOfCreditMfg &&
    pgmDetail.numOfCreditMfg !== '' &&
    AppConstants.NUMBER_REGEX.test(pgmDetail.numOfCreditMfg) === false
  ) {
    error.push(Messages.CREDIT_MANUFACTURERS_ERR);
    flderror = { ...flderror, numOfCreditMfgErr: true };
  }

  if (!pgmDetail.fiscalYearBeginDt || pgmDetail.fiscalYearBeginDt === '') {
    error.push(Messages.FISCAL_YR_REQ_ERR);
    flderror = { ...flderror, fiscalYrReqErr: true };
  }

  if (
    pgmDetail.fiscalYearBeginDt &&
    pgmDetail.fiscalYearBeginDt !== '' &&
    !validMMDDFormat(pgmDetail.fiscalYearBeginDt)
  ) {
    error.push(Messages.FISCAL_YR_ERR);
    flderror = { ...flderror, fiscalYrErr: true };
  }

  if (
    (!pgmDetail.invoiceHdrLine1 || pgmDetail.invoiceHdrLine1 === '') &&
    (!pgmDetail.invoiceHdrLine2 || pgmDetail.invoiceHdrLine2 === '') &&
    (!pgmDetail.invoiceHdrLine3 || pgmDetail.invoiceHdrLine3 === '') &&
    (!pgmDetail.invoiceHdrLine4 || pgmDetail.invoiceHdrLine4 === '')
  ) {
    error.push(Messages.INVOICE_HEADER_ERR);
    flderror = { ...flderror, invoiceHdrLineErr: true };
  }

  if (
    !pgmDetail.lastQtrWithoutClaims ||
    pgmDetail.lastQtrWithoutClaims === ''
  ) {
    error.push(Messages.LAST_QTR_REQ_ERR);
    flderror = { ...flderror, lastQtrWithoutClaimsReqErr: true };
  }

  if (
    pgmDetail.lastQtrWithoutClaims &&
    pgmDetail.lastQtrWithoutClaims !== '' &&
    !checkQuarterValidation(pgmDetail.lastQtrWithoutClaims)
  ) {
    error.push(constantMessageData.VALIDATE_QUARTER_VALUE);
    flderror = { ...flderror, lastQtrWithoutClaimsErr: true };
  }

  // if (!pgmDetail.firstSummaryRptQtr || pgmDetail.firstSummaryRptQtr === '') {
  //   error.push(Messages.FIRST_SUMMARY_QTR_REQ_ERR);
  //   flderror = { ...flderror, firstSummaryRptQtrReqErr: true };
  // }

  if (
    pgmDetail.firstSummaryRptQtr &&
    pgmDetail.firstSummaryRptQtr !== '' &&
    !checkQuarterValidation(pgmDetail.firstSummaryRptQtr)
  ) {
    error.push(constantMessageData.VALIDATE_QUARTER_VALUE);
    flderror = { ...flderror, firstSummaryRptQtrErr: true };
  }

  // if (
  //   !pgmDetail.dramsInvoiceStartQtr ||
  //   pgmDetail.dramsInvoiceStartQtr === ''
  // ) {
  //   error.push(Messages.DRAMS_QTR_REQ_ERR);
  //   flderror = { ...flderror, dramsInvoiceStartQtrReqErr: true };
  // }

  if (
    pgmDetail.dramsInvoiceStartQtr &&
    pgmDetail.dramsInvoiceStartQtr !== '' &&
    !checkQuarterValidation(pgmDetail.dramsInvoiceStartQtr)
  ) {
    error.push(constantMessageData.VALIDATE_QUARTER_VALUE);
    flderror = { ...flderror, dramsInvoiceStartQtrErr: true };
  }

  // case 'dayCountMethodCd':
  if (
    !pgmDetail?.dayCountMethodCd ||
    pgmDetail?.dayCountMethodCd === '' ||
    pgmDetail?.dayCountMethodCd === '-1'
  ) {
    error.push(Messages.DAY_COUNT_REQ_ERR);
    flderror = { ...flderror, dayCountReqErr: true };
  }

  // case 'drugTypeSourceCd':
  if (
    !pgmDetail?.drugTypeSourceCd ||
    pgmDetail?.drugTypeSourceCd === '' ||
    pgmDetail?.drugTypeSourceCd === '-1'
  ) {
    error.push(Messages.DRUG_TYPE_REQ_ERR);
    flderror = { ...flderror, drugTypeSourceCdReqErr: true };
  }

  // case 'nonCmsDrugInclQtrs':

  const quarterRequired =
    pgmDetail?.nonCmsDrugInclCd === 'NEWZERO' ||
    pgmDetail?.nonCmsDrugInclCd === 'NEWCALC'
      ? true
      : false;
  let qtrReqflag = false;

  if (quarterRequired === true && !pgmDetail.nonCmsDrugInclQtrs) {
    error.push(Messages.INCLUSION_QTR_ER);
    flderror = {
      ...flderror,
      nonCmsDrugInclQtrsReqErr: true,
      nonCmsDrugInclQtrsVldErr: false,
    };

    qtrReqflag = true;
  }

  if (qtrReqflag === false) {
    if (
      pgmDetail.nonCmsDrugInclQtrs &&
      pgmDetail.nonCmsDrugInclQtrs !== '' &&
      pgmDetail.nonCmsDrugInclQtrs !== null &&
      AppConstants.NUMBER_REGEX.test(pgmDetail.nonCmsDrugInclQtrs) === false
    ) {
      error.push(Messages.INCLUSION_QTR_VLD_ER);
      flderror = {
        ...flderror,
        nonCmsDrugInclQtrsVldErr: true,
        nonCmsDrugInclQtrsReqErr: false,
      };
    }
  }

  if (
    !pgmDetail.nonCmsDrugInclCd ||
    pgmDetail.nonCmsDrugInclCd === '' ||
    pgmDetail.nonCmsDrugInclCd === '-1'
  ) {
    error.push(Messages.INCLUSION_CODE_ERR);
    flderror = {
      ...flderror,
      nonCmsDrugInclCdErr: true,
    };
  }

  if (
    pgmDetail.frgvWoffThreshold &&
    pgmDetail.frgvWoffThreshold !== '' &&
    AppConstants.NUMBER_REGEX.test(pgmDetail.frgvWoffThreshold) === false
  ) {
    error.push(Messages.FORGIVE_THRESHOLD_NUM_ERR);
    flderror = {
      ...flderror,
      frgvWoffThresholdErr: true,
    };
  }

  if (
    pgmDetail.oldInvoicePrefix &&
    pgmDetail.oldInvoicePrefix !== '' &&
    AppConstants.NUMBER_REGEX.test(pgmDetail.oldInvoicePrefix) === false
  ) {
    error.push(Messages.OLD_INVOICE_PREFIX_NUM_ERR);
    flderror = {
      ...flderror,
      oldInvoicePrefixErr: true,
    };
  }

  if (
    pgmDetail.dbalModThreshold === '' ||
    pgmDetail.dbalModThreshold === null
  ) {
    error.push(Messages.DEC_THRES_REQ_ERR);
    flderror = { ...flderror, dbalModThresholdReqErr: true };
  }

  if (
    pgmDetail.dbalModThreshold &&
    pgmDetail.dbalModThreshold !== '' &&
    !AppConstants.AMOUNT.test(pgmDetail.dbalModThreshold)
  ) {
    error.push(Messages.DEC_THRES_ERR);
    flderror = { ...flderror, dbalModThresholdErr: true };
  }

  return { error, flderror };
};

export const pgmDetailsPayload = (pgmData, logInUser) => {
  // Details, Invoice Details, Default/Override Tab:
  return {
    rebateProgramCdVO: {
      planTypeCd: pgmData?.planTypeCd || '',
      rebateProgramCd: pgmData?.rebateProgramCd || '',
      useMcoServiceDtInd: pgmData?.useMcoServiceDtInd || 0,
      stubInvSeqNum: '0',
      useDefAuditsInd: pgmData?.useDefAuditsInd || 0,
      shortDescr: pgmData?.shortDescr || '',
      longDescr: pgmData?.longDescr || '',
      stateAbbrev: pgmData?.stateAbbrev || '',
      checkPayeeCd: pgmData?.checkPayeeCd || '',
      cms64AgencyName: pgmData?.cms64AgencyName || '',
      claimRebateProgramCd: pgmData?.claimRebateProgramCd || '',
      adjustmentQtrCd:
        pgmData?.adjustmentQtrCd && pgmData?.adjustmentQtrCd != -1
          ? pgmData?.adjustmentQtrCd
          : '',
      addWithNewFedInd: pgmData?.addWithNewFedInd || 0,
      defUseFedInvContactInd: pgmData?.defUseFedInvContactInd || 0,
      allowPriceEntryInd: pgmData?.allowPriceEntryInd || 0,
      allowEntryWithCmsUraInd: pgmData?.allowEntryWithCmsUraInd || 0,
      switchRosiPqasInd: pgmData?.switchRosiPqasInd || 0,
      useMemberNumberInd: pgmData?.useMemberNumberInd || 0,
      unitsUseReimbRatioInd: pgmData?.unitsUseReimbRatioInd || 0,
      allowCvgGapInd: pgmData?.allowCvgGapInd || 0,
      mcoRptInd: pgmData?.mcoRptInd || 0,
      fiscalYearBeginDt: pgmData?.fiscalYearBeginDt || '',
      lastQtrWithoutClaims: pgmData?.lastQtrWithoutClaims || '',
      dramsInvoiceStartQtr: pgmData?.dramsInvoiceStartQtr || null,
      firstSummaryRptQtr: pgmData?.firstSummaryRptQtr || null,
      rptBalanceDueThreshold:
        pgmData?.rptBalanceDueThreshold === null
          ? 0
          : pgmData?.rptBalanceDueThreshold,
      frgvWoffThreshold: pgmData?.frgvWoffThreshold || null,
      dbalModThreshold: pgmData?.dbalModThreshold || 0,
      dayCountMethodCd: pgmData?.dayCountMethodCd || '',
      drugTypeSourceCd: pgmData?.drugTypeSourceCd || '',
      disputeResolvedCd: pgmData?.disputeResolvedCd || '',
      numOfCreditMfg: pgmData?.numOfCreditMfg || '',
      numOfDebitMfg: pgmData?.numOfDebitMfg || '',
      rebateUnitTypeCd: pgmData?.rebateUnitTypeCd || '',
      assignDisputePriorDramsInd: pgmData?.assignDisputePriorDramsInd || 0,
      invoiceHdrLine1: pgmData?.invoiceHdrLine1 || '',
      invoiceHdrLine2: pgmData?.invoiceHdrLine2 || '',
      invoiceHdrLine3: pgmData?.invoiceHdrLine3 || '',
      invoiceHdrLine4: pgmData?.invoiceHdrLine4 || '',
      section4Ind: pgmData?.section4Ind || 0,
      coverLetterPlacementCd: pgmData?.coverLetterPlacementCd || '',
      flagUnitConversionInd: pgmData?.flagUnitConversionInd || 0,
      dispZeroUraInd: pgmData?.dispZeroUraInd || 0,
      dispNoUraInd: pgmData?.dispNoUraInd || 0,
      dispDupOnInvInd: pgmData?.dispDupOnInvInd || 0,
      inclZeroSubmitAmtClmInd: pgmData?.inclZeroSubmitAmtClmInd || 0,
      oldInvoicePrefix: pgmData?.oldInvoicePrefix || null,
      nonCmsDrugInclCd: pgmData?.nonCmsDrugInclCd || '',
      nonCmsDrugInclQtrs: pgmData?.nonCmsDrugInclQtrs || null,
      inclTplAmtInd: pgmData?.inclTplAmtInd || 0,
      inclCopayAmtInd: pgmData?.inclCopayAmtInd || 0,
      inclDeductibleAmtInd: pgmData?.inclDeductibleAmtInd || 0,
      process340bInd: pgmData?.process340bInd || 0,
      useFdInvFormatInd: pgmData?.useFdInvFormatInd || 0,
      inclVaccineInd: pgmData?.inclVaccineInd || 0,
      omitCmsDesiCheckInd: pgmData?.inclVaccineInd || 0,
      inclZeroReimbClmInd: pgmData?.inclZeroReimbClmInd || 0,
      useDefSystemInd: pgmData?.useDefSystemInd || 0,
      invoiceMailThreshold: pgmData?.invoiceMailThreshold || '',
      autoUnderThresholdInd: pgmData?.autoUnderThresholdInd || 0,
      reimbUnderThresholdMult: pgmData?.reimbUnderThresholdMult || 0,
      sendAllRetainedQtr: pgmData?.sendAllRetainedQtr || null,
      showDisputeOnInvInd: pgmData?.showDisputeOnInvInd || 0,
      forgiveReqCommentInd: pgmData?.forgiveReqCommentInd || 0,
      unitConvChangesDataInd: pgmData?.unitConvChangesDataInd || 0,
      nonZeroBilledUnitsInd: pgmData?.nonZeroBilledUnitsInd || 0,
      defEarliestQtrForDrugDtls: pgmData?.defEarliestQtrForDrugDtls || '',
      defDetailLevelOnInvoiceCd:
        pgmData?.defDetailLevelOnInvoiceCd &&
        pgmData?.defDetailLevelOnInvoiceCd != -1
          ? pgmData?.defDetailLevelOnInvoiceCd
          : '',
      progDefDispSpecialist:
        pgmData?.progDefDispSpecialist && pgmData?.progDefDispSpecialist != -1
          ? pgmData?.progDefDispSpecialist
          : '',
      defLetterSenderUserId:
        pgmData?.defLetterSenderUserId && pgmData?.defLetterSenderUserId != -1
          ? pgmData?.defLetterSenderUserId
          : '',
      lastUpdateUserId: logInUser,
    },
  };
};

export const uraSorcePayloadCons = (data = [], del, code, logInUser) => {
  return data.map((item) => {
    return {
      rpcParamPKVO: {
        rebateProgramCd: item.rebateProgramCd || code,
        startQtr: item.startQtr,
        rpcParamTypeCd: item.rpcParamTypeCd,
      },
      endQtr: item.endQtr || null,
      rpcParamValue: item.rpcParamValue,
      lastUpdateUserId: logInUser,
      isDeleteRecord: del,
    };
  });
};

export const uraCalcPayloadCons = (data = [], del, code, logInUser) => {
  return data.map((item) => {
    return {
      rpcCalcPctPKVO: {
        rebateProgramCd: item.rebateProgramCd || code,
        effectiveQtr: item.effectiveQtr,
        calcTypeCd: 'URA',
      },
      calcMethodCd: item.calcMethodCd,
      calcFixedPct: item.calcFixedPct,
      calcGenericPct: item.calcGenericPct,
      lastUpdateUserId: logInUser,
      isDeleteRecord: del,
    };
  });
};

export const uraPayPayloadCons = (data = [], del, code, logInUser) => {
  return data.map((item) => {
    return {
      rpcParamPKVO: {
        rebateProgramCd: item.rebateProgramCd || code,
        startQtr: item.startQtr,
        rpcParamTypeCd: item.rpcParamTypeCd,
      },
      endQtr: item.endQtr || null,
      rpcParamValue: item.rpcParamValue,
      lastUpdateUserId: logInUser,
      isDeleteRecord: del,
    };
  });
};

export const uraPmryPayload = (data, copyData, code, logInUser) => {
  let deleted = [];
  let copyparse = JSON.parse(copyData);
  let modified = data.rpcUraSource.filter((obj) => {
    let orgObj = copyparse.rpcUraSource.find((val) => val.id === obj.id);
    if (orgObj && obj.startQtr !== orgObj.startQtr) {
      deleted.push(orgObj);
      return obj;
    }
  });
  let updateRpcParamURASourceVOList = uraSorcePayloadCons(
    modified,
    0,
    code,
    logInUser
  );
  let deleteRpcParamURASourceVOList = uraSorcePayloadCons(
    deleted,
    0,
    code,
    logInUser
  );
  deleted = [];
  modified = data.rpcUraCal.filter((obj) => {
    let orgObj = copyparse.rpcUraCal.find((val) => val.id === obj.id);
    if (orgObj && obj.effectiveQtr !== orgObj.effectiveQtr) {
      deleted.push(orgObj);
      return obj;
    }
  });
  let updateRpcCalcPctURACalcVOList = uraCalcPayloadCons(
    modified,
    0,
    code,
    logInUser
  );
  let deleteRpcCalcPctURACalcVOList = uraCalcPayloadCons(
    deleted,
    0,
    code,
    logInUser
  );
  deleted = [];
  let modifie = data.rpcUrPayment.filter((obj) => {
    let orgObj = copyparse.rpcUrPayment.find((val) => val.id === obj.id);
    if (orgObj && obj.startQtr !== orgObj.startQtr) {
      deleted.push(orgObj);
      return obj;
    }
  });
  let updateRpcParamURAFromPaymentsVOList = uraPayPayloadCons(
    modifie,
    0,
    code,
    logInUser
  );
  let deleteRpcParamURAFromPaymentsVOList = uraPayPayloadCons(
    deleted,
    0,
    code,
    logInUser
  );
  return {
    updateRpcParamURASourceVOList,
    deleteRpcParamURASourceVOList,
    updateRpcCalcPctURACalcVOList,
    deleteRpcCalcPctURACalcVOList,
    updateRpcParamURAFromPaymentsVOList,
    deleteRpcParamURAFromPaymentsVOList,
  };
};

export const URAPayload = (URAGridData, delSrc, delCalc, delPay, code, id) => {
  // URA Tab -> URA Source
  let addRec = uraSorcePayloadCons(URAGridData.rpcUraSource, 0, code, id);
  let delRec = uraSorcePayloadCons(delSrc, 1, code, id);
  const rpcParamURASourceVOList = [...addRec, ...delRec];

  // URA Tab -> URA Calculation:
  addRec = uraCalcPayloadCons(URAGridData.rpcUraCal, 0, code, id);
  delRec = uraCalcPayloadCons(delCalc, 1, code, id);
  const rpcCalcPctURACalcVOList = [...addRec, ...delRec];

  // URA Tab -> Update URA From Payments
  addRec = uraPayPayloadCons(URAGridData.rpcUrPayment, 0, code, id);
  delRec = uraPayPayloadCons(delPay, 1, code, id);
  const rpcParamURAFromPaymentsVOList = [...addRec, ...delRec];

  return {
    rpcParamURASourceVOList,
    rpcCalcPctURACalcVOList,
    rpcParamURAFromPaymentsVOList,
  };
};

export const intCalcCons = (data = [], del, code, logInUser) => {
  return data.map((item) => {
    return {
      rpcCalcPctPKVO: {
        rebateProgramCd: item.rebateProgramCd || code,
        effectiveQtr: item.effectiveQtr,
        calcTypeCd: 'INT',
      },
      calcMethodCd: item.calcMethodCd,
      calcFixedPct: item.calcFixedPct,
      calcGenericPct: item.calcGenericPct,
      lastUpdateUserId: logInUser,
      isDeleteRecord: del,
    };
  });
};

export const intFedCons = (data = [], del, code, logInUser) => {
  return data.map((item) => {
    return {
      rpcParamPKVO: {
        rebateProgramCd: item.rebateProgramCd || code,
        startQtr: item.startQtr,
        rpcParamTypeCd: item.rpcParamTypeCd,
      },
      endQtr: item.endQtr || null,
      rpcParamValue: item.rpcParamValue,
      lastUpdateUserId: logInUser,
      isDeleteRecord: del,
    };
  });
};

export const intFmlyCons = (data = [], del, code, logInUser) => {
  return data.map((item) => {
    return {
      rpcParamPKVO: {
        rebateProgramCd: item.rebateProgramCd || code,
        startQtr: item.startQtr,
        rpcParamTypeCd: item.rpcParamTypeCd,
      },
      endQtr: item.endQtr || null,
      rpcParamValue: item.rpcParamValue,
      lastUpdateUserId: logInUser,
      isDeleteRecord: del,
    };
  });
};

export const intPmryPayload = (data, copyData, code, logInUser) => {
  let deleted = [];
  let copyparse = JSON.parse(copyData);
  let modified = data.rpcCalcPctVOIntShareFedaralList.filter((obj) => {
    let orgObj = copyparse.rpcCalcPctVOIntShareFedaralList.find(
      (val) => val.id === obj.id
    );
    if (orgObj && obj.startQtr !== orgObj.startQtr) {
      deleted.push(orgObj);
      return obj;
    }
  });
  let updateRpcParamIntShareFederalPctVOList = intFedCons(
    modified,
    0,
    code,
    logInUser
  );
  let deleteRpcParamIntShareFederalPctVOList = intFedCons(
    deleted,
    0,
    code,
    logInUser
  );
  deleted = [];
  modified = data.rpcParamVoIntShareIntCalList.filter((obj) => {
    let orgObj = copyparse.rpcParamVoIntShareIntCalList.find(
      (val) => val.id === obj.id
    );
    if (orgObj && obj.effectiveQtr !== orgObj.effectiveQtr) {
      deleted.push(orgObj);
      return obj;
    }
  });
  let updateRpcCalcPctInterestCalcVOList = intCalcCons(
    modified,
    0,
    code,
    logInUser
  );
  let deleteRpcCalcPctInterestCalcVOList = intCalcCons(
    deleted,
    0,
    code,
    logInUser
  );
  deleted = [];
  modified = data.rpcParamVoIntShareFedaralFamiliList.filter((obj) => {
    let orgObj = copyparse.rpcParamVoIntShareFedaralFamiliList.find(
      (val) => val.id === obj.id
    );
    if (orgObj && obj.startQtr !== orgObj.startQtr) {
      deleted.push(orgObj);
      return obj;
    }
  });
  let updateUpcParamIntShareFederalFamilyPlanPctVOList = intFmlyCons(
    modified,
    0,
    code,
    logInUser
  );
  let deleteRpcParamIntShareFederalFamilyPlanPctVOList = intFmlyCons(
    deleted,
    0,
    code,
    logInUser
  );
  return {
    updateRpcParamIntShareFederalPctVOList,
    deleteRpcParamIntShareFederalPctVOList,
    updateRpcCalcPctInterestCalcVOList,
    deleteRpcCalcPctInterestCalcVOList,
    updateUpcParamIntShareFederalFamilyPlanPctVOList,
    deleteRpcParamIntShareFederalFamilyPlanPctVOList,
  };
};

export const IntSharePayload = (
  IntGridData,
  delCalc,
  delFed,
  delFmly,
  cod,
  planType,
  i
) => {
  // Int/Share Tab-> Interest Calculation:
  let addRec = intCalcCons(IntGridData.rpcParamVoIntShareIntCalList, 0, cod, i);
  let delRec = intCalcCons(delCalc, 1, cod, i);
  // const rpcCalcPctInterestCalcVOList =
  //   planType === 'FD' ? [] : [...addRec, ...delRec];
  const rpcCalcPctInterestCalcVOList = [...addRec, ...delRec];
  // Int/Share Tab-> Federal %
  addRec = intFedCons(IntGridData.rpcCalcPctVOIntShareFedaralList, 0, cod, i);
  delRec = intFedCons(delFed, 1, cod, i);
  const rpcParamIntShareFederalPctVOList = [...addRec, ...delRec];
  // Int/Share Tab-> Federal Family Planning %
  addRec = intFmlyCons(
    IntGridData.rpcParamVoIntShareFedaralFamiliList,
    0,
    cod,
    i
  );
  delRec = intFmlyCons(delFmly, 1, cod, i);
  const rpcParamIntShareFederalFamilyPlanPctVOList = [...addRec, ...delRec];
  return {
    rpcCalcPctInterestCalcVOList,
    rpcParamIntShareFederalPctVOList,
    rpcParamIntShareFederalFamilyPlanPctVOList,
  };
};

export const cmsRptCons = (data = [], del, code, logInUser) => {
  return data.map((item) => {
    return {
      rebateProgramCd: item.rebateProgramCd || code,
      startQtr: item.startQtr,
      endQtr: item.endQtr,
      groupNum: item.cmsRptGroupNum,
      groupName: item.cmsRptGroupName,
      reportTitle: item.cmsRptTitle,
      lastUpdateUserId: logInUser,
      isDeleteRecord: del,
    };
  });
};

export const cmsUtilCons = (data = [], del, code, logInUser) => {
  return data.map((item) => {
    return {
      rebateProgramCd: item.rebateProgramCd || code,
      startQtr: item.startQtr,
      endQtr: item.endQtr,
      groupNum: item.cmsUtilGroupNum,
      groupName: item.cmsUtilGroupName,
      lastUpdateUserId: logInUser,
      isDeleteRecord: del,
    };
  });
};

export const grpPmryPayload = (data, copyData, code, logInUser) => {
  let deleted = [];
  let copyparse = JSON.parse(copyData);
  let modified = data.cmsReporting.filter((obj) => {
    let orgObj = copyparse.cmsReporting.find((val) => val.id === obj.id);
    if (orgObj && obj.startQtr !== orgObj.startQtr) {
      deleted.push(orgObj);
      return obj;
    }
  });
  let updateRpcParamGroupReportingVOList = cmsRptCons(
    modified,
    0,
    code,
    logInUser
  );
  let deleteRpcParamGroupReportingVOList = cmsRptCons(
    deleted,
    0,
    code,
    logInUser
  );
  deleted = [];
  modified = data.cmsUtilization.filter((obj) => {
    let orgObj = copyparse.cmsUtilization.find((val) => val.id === obj.id);
    if (orgObj && obj.startQtr !== orgObj.startQtr) {
      deleted.push(orgObj);
      return obj;
    }
  });
  let updateRpcParamGroupUtilizationVOList = cmsUtilCons(
    modified,
    0,
    code,
    logInUser
  );
  let deleteRpcParamGroupUtilizationVOList = cmsUtilCons(
    deleted,
    0,
    code,
    logInUser
  );
  return {
    updateRpcParamGroupReportingVOList,
    deleteRpcParamGroupReportingVOList,
    updateRpcParamGroupUtilizationVOList,
    deleteRpcParamGroupUtilizationVOList,
  };
};

export const GroupPayload = (groupGridData, delRpt, delUtil, code, user) => {
  // Group Tab -> CMS Reporting below record is for each row in UI
  let addRec = cmsRptCons(groupGridData.cmsReporting, 0, code, user);
  let delRec = cmsRptCons(delRpt, 1, code);
  const rpcParamGroupReportingVOList = [...addRec, ...delRec];
  // Group Tab -> CMS Utilization below records is for each row in UI
  addRec = cmsUtilCons(groupGridData.cmsUtilization, 0, code, user);
  delRec = cmsUtilCons(delUtil, 1, code);
  const rpcParamGroupUtilizationVOList = [...addRec, ...delRec];
  return { rpcParamGroupReportingVOList, rpcParamGroupUtilizationVOList };
};

export const enrollCons = (data = [], del, code, logInUser) => {
  return data.map((item) => {
    return {
      rpcEnrollmentPKVO: {
        rebateProgramCd: item.rebateProgramCd || code,
        qtr: item.qtr,
        enrollmentTimingCd: item.enrollmentTimingCd,
      },
      numOfLives: item.numOfLives,
      lastUpdateUserId: logInUser,
      isDeleteRecord: del,
    };
  });
};

export const enrollPmryPayload = (data, copyData, code, logInUser) => {
  let deleted = [];
  let copyparse = JSON.parse(copyData);
  let modified = data.filter((obj) => {
    let orgObj = copyparse.find((val) => val.id === obj.id);
    if (orgObj && obj.qtr !== orgObj.qtr) {
      deleted.push(orgObj);
      return obj;
    }
  });
  let updateRpcEnrollmentVOList = enrollCons(modified, 0, code, logInUser);
  let deleteRpcEnrollmentVOList = enrollCons(deleted, 0, code, logInUser);
  return {
    updateRpcEnrollmentVOList,
    deleteRpcEnrollmentVOList,
  };
};

export const EnrollmentPayload = (enrollGridData, delEnroll, code, user) => {
  // Enrollment Tab:
  let addRec = enrollCons(enrollGridData, 0, code, user);
  let delRec = enrollCons(delEnroll, 1, code, user);
  const rpcEnrollmentVOList = [...addRec, ...delRec];
  return { rpcEnrollmentVOList };
};

export const isValidRebatePgm = (values) => {
  return axios
    .post(serviceEndPoint.VALIDATE_REBATE_PGM, values)
    .then((response) => {
      return response.data.isRebateProgramExists ? false : true;
    })
    .catch((response) => {
      return false;
    });
};

export const fieldValidation = (val, fld, err, flderr, extraCondition = '') => {
  let error = err;
  let flderror = flderr;
  let qtrReqflag = false;
  let auditFldBlur = false;
  switch (fld) {
    case 'shortDescr':
      if (val === '') {
        error = [...new Set([...err, Messages.SHORT_DESC_ERR])];
        flderror = { ...flderr, shtDescErr: true };
      } else {
        error = removeErr(err, [Messages.SHORT_DESC_ERR]);
        // flderror = delete flderr.shtDescErr;
        flderror = { ...flderr, shtDescErr: false };
      }
      break;
    case 'longDescr':
      if (val === '') {
        error = [...new Set([...err, Messages.LONG_DESC_ERR])];
        flderror = { ...flderr, longDescErr: true };
      } else {
        error = removeErr(err, [Messages.LONG_DESC_ERR]);
        // flderror = delete flderr.longDescErr;
        flderror = { ...flderr, longDescErr: false };
      }
      break;

    case 'rebateProgramCd':
      if (val === '') {
        error = [...new Set([...err, Messages.REBETE_PGM_ERR])];
        flderror = {
          ...flderr,
          rebatePgmErr: true,
          rebatePgmInvalidErr: false,
        };
      } else if (val !== '' && !extraCondition) {
        error = [...new Set([...err, Messages.REBETE_PGM_INVALID_ERR])];
        flderror = {
          ...flderr,
          rebatePgmErr: false,
          rebatePgmInvalidErr: true,
        };
      } else {
        error = removeErr(err, [
          Messages.REBETE_PGM_ERR,
          Messages.REBETE_PGM_INVALID_ERR,
        ]);
        // flderror = delete flderr.rebatePgmErr;
        flderror = {
          ...flderr,
          rebatePgmErr: false,
          rebatePgmInvalidErr: false,
        };
      }
      break;
    case 'checkPayeeCd':
      if (val === '' || val === '-1') {
        error = [...new Set([...err, Messages.CHECK_PAY_ERR])];
        flderror = { ...flderr, checkPayErr: true };
      } else {
        error = removeErr(err, [Messages.CHECK_PAY_ERR]);
        // flderror = delete flderr.checkPayErr;
        flderror = { ...flderr, checkPayErr: false };
      }
      break;
    case 'cms64AgencyName':
      if ((!val || val === '') && extraCondition === 'FD') {
        error = [...new Set([...err, Messages.CMS64_ERR])];
        flderror = { ...flderr, cms64Err: true };
      } else {
        error = removeErr(err, [Messages.CMS64_ERR]);
        // flderror = delete flderr.cms64Err;
        flderror = { ...flderr, cms64Err: false };
      }
      break;
    case 'stateAbbrev':
      if ((val === '' || val === '-1') && extraCondition !== 'COMM') {
        error = [...new Set([...err, Messages.STATE_ERR])];
        flderror = { ...flderr, stateErr: true };
      } else {
        error = removeErr(err, [Messages.STATE_ERR]);
        // flderror = delete flderr.stateErr;
        flderror = { ...flderr, stateErr: false };
      }
      break;
    case 'defEarliestQtrForDrugDtls':
      error = removeErr(err, [
        Messages.EARLIER_QTR_ERR,
        constantMessageData.VALIDATE_QUARTER_VALUE,
      ]);

      if (val === '') {
        error = [...new Set([...err, Messages.EARLIER_QTR_ERR])];
        flderror = {
          ...flderr,
          earlierQtrReqErr: true,
          earlierQtrQtrErr: false,
        };
      } else if (val !== '' && !checkQuarterValidation(val)) {
        error = [
          ...new Set([...err, constantMessageData.VALIDATE_QUARTER_VALUE]),
        ];
        flderror = {
          ...flderr,
          earlierQtrReqErr: false,
          earlierQtrQtrErr: true,
        };
      } else {
        error = removeErr(err, [
          Messages.EARLIER_QTR_ERR,
          constantMessageData.VALIDATE_QUARTER_VALUE,
        ]);
        // flderror = delete flderr.earlierQtrReqErr;
        flderror = {
          ...flderr,
          earlierQtrReqErr: false,
          earlierQtrQtrErr: false,
        };
      }
      break;
    case 'dbalModThreshold':
      error = removeErr(err, [
        Messages.DEC_THRES_ERR,
        Messages.DEC_THRES_REQ_ERR,
      ]);
      if (val === '' || val === null) {
        error = [...new Set([...err, Messages.DEC_THRES_REQ_ERR])];
        flderror = {
          ...flderr,
          dbalModThresholdReqErr: true,
          dbalModThresholdErr: false,
        };
      } else if (val && !AppConstants.AMOUNT.test(val)) {
        error = [...new Set([...err, Messages.DEC_THRES_ERR])];
        flderror = {
          ...flderr,
          dbalModThresholdReqErr: false,
          dbalModThresholdErr: true,
        };
      } else {
        error = removeErr(err, [
          Messages.DEC_THRES_ERR,
          Messages.DEC_THRES_REQ_ERR,
        ]);
        flderror = {
          ...flderr,
          dbalModThresholdReqErr: false,
          dbalModThresholdErr: false,
        };
      }
      break;
    case 'sendAllRetainedQtr':
      if (
        (val !== '' && AppConstants.NUMBER_REGEX.test(val) === false) ||
        parseInt(val, 10) < 0 ||
        parseInt(val, 10) > 4
      ) {
        error = [...new Set([...err, Messages.SEND_ALL_RETAINED_QTR])];
        flderror = {
          ...flderr,
          sendAllRetainedQtrErr: true,
        };
      } else {
        error = removeErr(err, [Messages.SEND_ALL_RETAINED_QTR]);
        // flderror = delete flderr.earlierQtrReqErr;
        flderror = {
          ...flderr,
          sendAllRetainedQtrErr: false,
        };
      }
      break;

    case 'rptBalanceDueThreshold':
      error = removeErr(err, [
        Messages.REPORT_BALANCE_DUE_REQ_ERR,
        Messages.REPORT_BALANCE_DUE_ERR,
      ]);

      if (val === '') {
        error = [...new Set([...err, Messages.REPORT_BALANCE_DUE_REQ_ERR])];
        flderror = {
          ...flderr,
          rptBalanceDueThresholdReqErr: true,
          rptBalanceDueThresholdErr: false,
        };
      } else if (val !== '' && AppConstants.AMOUNT.test(val) === false) {
        error = [...new Set([...err, Messages.REPORT_BALANCE_DUE_ERR])];
        flderror = {
          ...flderr,
          rptBalanceDueThresholdReqErr: false,
          rptBalanceDueThresholdErr: true,
        };
      } else {
        error = removeErr(err, [
          Messages.REPORT_BALANCE_DUE_REQ_ERR,
          Messages.REPORT_BALANCE_DUE_ERR,
        ]);
        // flderror = delete flderr.earlierQtrReqErr;
        flderror = {
          ...flderr,
          rptBalanceDueThresholdReqErr: false,
          rptBalanceDueThresholdErr: false,
        };
      }
      break;

    case 'invoiceMailThreshold':
      if ((val !== '' && isNaN(parseFloat(val))) || parseInt(val, 10) > 50) {
        error = [...new Set([...err, Messages.INVOICE_MAIL_ERR])];
        flderror = {
          ...flderr,
          invoiceMailThresholdErr: true,
        };
      } else {
        error = removeErr(err, [Messages.INVOICE_MAIL_ERR]);
        // flderror = delete flderr.earlierQtrReqErr;
        flderror = {
          ...flderr,
          invoiceMailThresholdErr: false,
        };
      }
      break;

    case 'numOfDebitMfg':
      if (val !== '' && AppConstants.NUMBER_REGEX.test(val) === false) {
        error = [...new Set([...err, Messages.DEBIT_MANUFACTURERS_ERR])];
        flderror = { ...flderr, numOfDebitMfgErr: true };
      } else {
        error = removeErr(err, [Messages.DEBIT_MANUFACTURERS_ERR]);
        // flderror = delete flderr.numOfDebitMfgErr;
        flderror = { ...flderr, numOfDebitMfgErr: false };
      }
      break;
    case 'numOfCreditMfg':
      if (val !== '' && AppConstants.NUMBER_REGEX.test(val) === false) {
        error = [...new Set([...err, Messages.CREDIT_MANUFACTURERS_ERR])];
        flderror = { ...flderr, numOfCreditMfgErr: true };
      } else {
        error = removeErr(err, [Messages.CREDIT_MANUFACTURERS_ERR]);
        // flderror = delete flderr.numOfCreditMfgErr;
        flderror = { ...flderr, numOfCreditMfgErr: false };
      }
      break;
    case 'fiscalYearBeginDt':
      if (!val || val === '') {
        error = [...new Set([...err, Messages.FISCAL_YR_REQ_ERR])];
        flderror = { ...flderr, fiscalYrReqErr: true, fiscalYrErr: false };
      } else if (val !== '' && !validMMDDFormat(val)) {
        error = [...new Set([...err, Messages.FISCAL_YR_ERR])];
        flderror = { ...flderr, fiscalYrReqErr: false, fiscalYrErr: true };
      } else {
        error = removeErr(err, [
          Messages.FISCAL_YR_ERR,
          Messages.FISCAL_YR_REQ_ERR,
        ]);
        // flderror = delete flderr.fiscalYrErr;
        flderror = { ...flderr, fiscalYrReqErr: false, fiscalYrErr: false };
      }
      break;

    case 'invoiceHdrLine':
      if (
        (!extraCondition.invoiceHdrLine1 ||
          extraCondition.invoiceHdrLine1 === '') &&
        (!extraCondition.invoiceHdrLine2 ||
          extraCondition.invoiceHdrLine2 === '') &&
        (!extraCondition.invoiceHdrLine3 ||
          extraCondition.invoiceHdrLine3 === '') &&
        (!extraCondition.invoiceHdrLine4 ||
          extraCondition.invoiceHdrLine4 === '')
      ) {
        error = [...new Set([...err, Messages.INVOICE_HEADER_ERR])];
        flderror = { ...flderr, invoiceHdrLineErr: true };
      } else {
        error = removeErr(err, [Messages.INVOICE_HEADER_ERR]);
        // flderror = delete flderr.invoiceHdrLineErr;
        flderror = { ...flderr, invoiceHdrLineErr: false };
      }
      break;
    case 'lastQtrWithoutClaims':
      if (!val || val === '') {
        error = [...new Set([...err, Messages.LAST_QTR_REQ_ERR])];
        flderror = {
          ...flderr,
          lastQtrWithoutClaimsErr: false,
          lastQtrWithoutClaimsReqErr: true,
        };
      } else if (val !== '' && !checkQuarterValidation(val)) {
        error = [
          ...new Set([...err, constantMessageData.VALIDATE_QUARTER_VALUE]),
        ];
        flderror = {
          ...flderr,
          lastQtrWithoutClaimsErr: true,
          lastQtrWithoutClaimsReqErr: false,
        };
      } else {
        error = removeErr(err, [
          Messages.LAST_QTR_REQ_ERR,
          constantMessageData.VALIDATE_QUARTER_VALUE,
        ]);
        // flderror = delete flderr.lastQtrWithoutClaimsErr;
        flderror = {
          ...flderr,
          lastQtrWithoutClaimsErr: false,
          lastQtrWithoutClaimsReqErr: false,
        };
      }
      break;
    case 'firstSummaryRptQtr':
      // if (!val || val === '') {
      //   error = [...new Set([...err, Messages.FIRST_SUMMARY_QTR_REQ_ERR])];
      //   flderror = {
      //     ...flderr,
      //     firstSummaryRptQtrErr: false,
      //     firstSummaryRptQtrReqErr: true,
      //   };
      // } else
      if (val !== '' && !checkQuarterValidation(val)) {
        error = [
          ...new Set([...err, constantMessageData.VALIDATE_QUARTER_VALUE]),
        ];
        flderror = {
          ...flderr,
          firstSummaryRptQtrErr: true,
          // firstSummaryRptQtrReqErr: false,
        };
      } else {
        error = removeErr(err, [
          constantMessageData.VALIDATE_QUARTER_VALUE,
          // Messages.FIRST_SUMMARY_QTR_REQ_ERR,
        ]);
        // flderror = delete flderr.firstSummaryRptQtrErr;
        flderror = {
          ...flderr,
          firstSummaryRptQtrErr: false,
          // firstSummaryRptQtrReqErr: false,
        };
      }
      break;
    case 'dramsInvoiceStartQtr':
      // if (!val || val === '') {
      //   error = [...new Set([...err, Messages.DRAMS_QTR_REQ_ERR])];
      //   flderror = {
      //     ...flderr,
      //     dramsInvoiceStartQtrErr: false,
      //     dramsInvoiceStartQtrReqErr: true,
      //   };
      // } else
      if (val !== '' && !checkQuarterValidation(val)) {
        error = [
          ...new Set([...err, constantMessageData.VALIDATE_QUARTER_VALUE]),
        ];
        flderror = {
          ...flderr,
          dramsInvoiceStartQtrErr: true,
          // dramsInvoiceStartQtrReqErr: false,
        };
      } else {
        error = removeErr(err, [
          constantMessageData.VALIDATE_QUARTER_VALUE,
          //Messages.DRAMS_QTR_REQ_ERR,
        ]);
        // flderror = delete flderr.dramsInvoiceStartQtrErr;
        flderror = {
          ...flderr,
          dramsInvoiceStartQtrErr: false,
          // dramsInvoiceStartQtrReqErr: false,
        };
      }
      break;
    case 'nonCmsDrugInclQtrs':
      if (extraCondition && val === '') {
        error = [...new Set([...err, Messages.INCLUSION_QTR_ER])];
        flderror = {
          ...flderr,
          nonCmsDrugInclQtrsReqErr: true,
          nonCmsDrugInclQtrsVldErr: false,
        };
        qtrReqflag = true;
      } else {
        error = removeErr(err, [Messages.INCLUSION_QTR_ER]);
        // flderror = delete flderr.nonCmsDrugInclQtrsReqErr;
        flderror = {
          ...flderr,
          nonCmsDrugInclQtrsReqErr: false,
          nonCmsDrugInclQtrsVldErr: false,
        };
        qtrReqflag = false;
      }

      if (qtrReqflag === false) {
        if (
          val !== '' &&
          val !== null &&
          AppConstants.NUMBER_REGEX.test(val) === false
        ) {
          error = [...new Set([...err, Messages.INCLUSION_QTR_VLD_ER])];
          flderror = {
            ...flderr,
            nonCmsDrugInclQtrsVldErr: true,
            nonCmsDrugInclQtrsReqErr: false,
          };
        } else {
          error = removeErr(err, [Messages.INCLUSION_QTR_VLD_ER]);
          // flderror = delete flderr.nonCmsDrugInclQtrsVldErr;
          flderror = {
            ...flderr,
            nonCmsDrugInclQtrsVldErr: false,
            nonCmsDrugInclQtrsReqErr: false,
          };
        }
      }
      break;

    case 'nonCmsDrugInclCd':
      if (val === '' || val === '-1') {
        error = [...new Set([...err, Messages.INCLUSION_CODE_ERR])];
        flderror = { ...flderr, nonCmsDrugInclCdErr: true };
      } else {
        error = removeErr(err, [Messages.INCLUSION_CODE_ERR]);
        // flderror = delete flderr.nonCmsDrugInclCdErr;
        flderror = { ...flderr, nonCmsDrugInclCdErr: false };   
      }
      if (val !== 'NEWZERO' || val !== 'NEWCALC')
        error = removeErr(error, [
          Messages.INCLUSION_QTR_ER,
          Messages.INCLUSION_QTR_VLD_ER,
        ]);
      flderror = {
        ...flderror,
        nonCmsDrugInclQtrsVldErr: false,
        nonCmsDrugInclQtrsReqErr: false,
      };
      break;
    case 'frgvWoffThreshold':
      if (val !== '' && AppConstants.AMOUNT.test(val) === false) {
        error = [...new Set([...err, Messages.FORGIVE_THRESHOLD_NUM_ERR])];
        flderror = { ...flderr, frgvWoffThresholdErr: true };
      } else {
        error = removeErr(err, [Messages.FORGIVE_THRESHOLD_NUM_ERR]);
        // flderror = delete flderr.frgvWoffThresholdErr;
        flderror = { ...flderr, frgvWoffThresholdErr: false };
      }
      break;
    case 'oldInvoicePrefix':
      if (val !== '' && AppConstants.NUMBER_REGEX.test(val) === false) {
        error = [...new Set([...err, Messages.OLD_INVOICE_PREFIX_NUM_ERR])];
        flderror = { ...flderr, oldInvoicePrefixErr: true };
      } else {
        error = removeErr(err, [Messages.OLD_INVOICE_PREFIX_NUM_ERR]);
        // flderror = delete flderr.oldInvoicePrefixErr;
        flderror = { ...flderr, oldInvoicePrefixErr: false };
      }
      break;
    case 'IRGLtestPct':
      if (val === '' || !AppConstants.TWO_DECIMAL_REGEX.test(val)) {
        error = [...new Set([...err, Messages.PER_PRIOR_ERR])];
        flderror = { ...flderr, IRGLtestPctErr: true };
      } else {
        auditFldBlur = true;
        error = removeErr(err, [Messages.PER_PRIOR_ERR]);
        flderror = delete flderr.IRGLtestPctErr;
        // flderror = { ...flderr, IRGLtestPctErr: false };
      }
      break;
    case 'IRGRtestPct':
      if (val === '' || !AppConstants.TWO_DECIMAL_REGEX.test(val)) {
        error = [...new Set([...err, Messages.PER_REB_AMT_ERR])];
        flderror = { ...flderr, IRGRtestPctErr: true };
      } else {
        auditFldBlur = true;
        error = removeErr(err, [Messages.PER_REB_AMT_ERR]);
        flderror = delete flderr.IRGRtestPctErr;
        // flderror = { ...flderr, IRGRtestPctErr: false };
      }
      break;
    case 'IRGPtestPct':
      if (val === '' || !AppConstants.TWO_DECIMAL_REGEX.test(val)) {
        error = [...new Set([...err, Messages.PER_PRIOR_ERR])];
        flderror = { ...flderr, IRGPtestPctErr: true };
      } else {
        auditFldBlur = true;
        error = removeErr(err, [Messages.PER_PRIOR_ERR]);
        flderror = delete flderr.IRGPtestPctErr;
        // flderror = { ...flderr, IRGPtestPctErr: false };
      }
      break;
    case 'IUNPtestPct':
      if (val === '' || !AppConstants.TWO_DECIMAL_REGEX.test(val)) {
        error = [...new Set([...err, Messages.PER_PRIOR_ERR])];
        flderror = { ...flderr, IUNPtestPctErr: true };
      } else {
        auditFldBlur = true;
        error = removeErr(err, [Messages.PER_PRIOR_ERR]);
        flderror = delete flderr.IUNPtestPctErr;
        // flderror = { ...flderr, IUNPtestPctErr: false };
      }
      break;
    case 'CSTRtestAmt':
      if (val === '' || !AppConstants.TWO_DECIMAL_REGEX.test(val)) {
        error = [...new Set([...err, Messages.THRES_AMT_ERR])];
        flderror = { ...flderr, CSTRtestAmtErr: true };
      } else {
        auditFldBlur = true;
        error = removeErr(err, [Messages.THRES_AMT_ERR]);
        flderror = delete flderr.CSTRtestAmtErr;
        // flderror = { ...flderr, CSTRtestAmtErr: false };
      }
      break;
    case 'CRLAtestAmt':
      if (val === '' || !AppConstants.TWO_DECIMAL_REGEX.test(val)) {
        error = [...new Set([...err, Messages.PER_ALLOW_ERR])];
        flderror = { ...flderr, CRLAtestAmtErr: true };
      } else {
        auditFldBlur = true;
        error = removeErr(err, [Messages.PER_ALLOW_ERR]);
        flderror = delete flderr.CRLAtestAmtErr;
        // flderror = { ...flderr, CRLAtestAmtErr: false };
      }
      break;
    case 'CSRAtestAmt':
      if (val === '' || !AppConstants.TWO_DECIMAL_REGEX.test(val)) {
        error = [...new Set([...err, Messages.PER_SUB_ERR])];
        flderror = { ...flderr, CSRAtestAmtErr: true };
      } else {
        auditFldBlur = true;
        error = removeErr(err, [Messages.PER_SUB_ERR]);
        flderror = delete flderr.CSRAtestAmtErr;
        // flderror = { ...flderr, CSRAtestAmtErr: false };
      }
      break;
    case 'CAEStestAmt':
      if (val === '' || !AppConstants.TWO_DECIMAL_REGEX.test(val)) {
        error = [...new Set([...err, Messages.PER_SUB_ERR])];
        flderror = { ...flderr, CAEStestAmtErr: true };
      } else {
        auditFldBlur = true;
        error = removeErr(err, [Messages.PER_SUB_ERR]);
        flderror = delete flderr.CAEStestAmtErr;
        // flderror = { ...flderr, CAEStestAmtErr: false };
      }
      break;
    case 'CUNAtestAmt':
      if (val === '' || !AppConstants.TWO_DECIMAL_REGEX.test(val)) {
        error = [...new Set([...err, Messages.AVG_PER_REQ_ERR])];
        flderror = { ...flderr, CUNAtestAmtErr: true };
      } else {
        auditFldBlur = true;
        error = removeErr(err, [Messages.AVG_PER_REQ_ERR]);
        flderror = delete flderr.CUNAtestAmtErr;
        // flderror = { ...flderr, CUNAtestAmtErr: false };
      }
      break;
    case 'dayCountMethodCd':
      if (val === '' || val === '-1') {
        error = [...new Set([...err, Messages.DAY_COUNT_REQ_ERR])];
        flderror = { ...flderr, dayCountReqErr: true };
      } else {
        error = removeErr(err, [Messages.DAY_COUNT_REQ_ERR]);
        // flderror = delete flderr.dayCountReqErr;
        flderror = { ...flderr, dayCountReqErr: false };
      }
      break;
    case 'drugTypeSourceCd':
      if (!val || val === '' || val === '-1') {
        error = [...new Set([...err, Messages.DRUG_TYPE_REQ_ERR])];
        flderror = { ...flderr, drugTypeSourceCdReqErr: true };
      } else {
        error = removeErr(err, [Messages.DRUG_TYPE_REQ_ERR]);
        // flderror = delete flderr.drugTypeSourceCdReqErr;
        flderror = { ...flderr, drugTypeSourceCdReqErr: false };
      }
      break;
    case 'claimRebateProgramCd':
      if ((!val || val === '' || val === '-1') && extraCondition === 'SUPP') {
        error = [...new Set([...err, Messages.CLAIM_REBATE_PGM_REQ_ERR])];
        flderror = { ...flderr, claimRebateProgramCdReqErr: true };
      } else {
        error = removeErr(err, [Messages.CLAIM_REBATE_PGM_REQ_ERR]);
        // flderror = delete flderr.claimRebateProgramCdReqErr;
        flderror = { ...flderr, claimRebateProgramCdReqErr: false };
      }
      break;
    default:
    // do nothing
  }
  return { error, flderror, auditFldBlur };
};

export const defaultDataForAudits = (defs, units, mul100) => {
  const n = !_.isEmpty(defs)
    ? defs.filter(
        (o) =>
          o.paramTestIdVO.defTestUnitTypeCd !== ' ' &&
          o.paramTestIdVO.defTestTypeCd === 'UNT'
      )
    : [];
  const unitData = n.map((o) => {
    const desc = units.filter(
      (ob) => ob.codeValueID.codeValue === o.paramTestIdVO.defTestUnitTypeCd
    );
    const data = {
      testGroupCd: o.paramTestIdVO.defTestGroupCd,
      testTypeCd: 'UNT',
      testUnitTypeCd: o.paramTestIdVO.defTestUnitTypeCd,
      testOnInd: o.defTestOnInd,
      testPct: o.defTestPct,
      testAmt: o.defTestAmt,
      mailOrderMultiplier: o.defMailOrderMultiplier,
      shortDescription: desc?.[0]?.shortDescription,
      codeValue: o.paramTestIdVO.defTestUnitTypeCd,
      longDescription: desc?.[0]?.longDescription,
    };
    return data;
  });
  const audit = defauditTabDataCons(defs, mul100);
  return { unitData, audit };
};

export const defauditTabDataCons = (obj, mul100) => {
  const b = {};
  if (!_.isEmpty(obj)) {
    obj.forEach((val) => {
      if (
        val.paramTestIdVO.defTestGroupCd === 'C' &&
        val.paramTestIdVO.defTestTypeCd === 'UNA'
      ) {
        b.CUNAtestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
        b.CUNAtestAmt = mul100
          ? parseFloat(val.defTestPct * 100 || 0).toFixed(2)
          : parseFloat(val.defTestPct || 0).toFixed(2);
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'C' &&
        val.paramTestIdVO.defTestTypeCd === 'RES'
      ) {
        b.CREStestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'C' &&
        val.paramTestIdVO.defTestTypeCd === 'AES'
      ) {
        b.CAEStestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
        b.CAEStestAmt = mul100
          ? parseFloat(val.defTestPct * 100 || 0).toFixed(2)
          : parseFloat(val.defTestPct || 0).toFixed(2);
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'C' &&
        val.paramTestIdVO.defTestTypeCd === 'SRA'
      ) {
        b.CSRAtestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
        b.CSRAtestAmt = mul100
          ? parseFloat(val.defTestPct * 100 || 0).toFixed(2)
          : parseFloat(val.defTestPct || 0).toFixed(2);
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'C' &&
        val.paramTestIdVO.defTestTypeCd === 'RLA'
      ) {
        b.CRLAtestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
        b.CRLAtestAmt = mul100
          ? parseFloat(val.defTestPct * 100 || 0).toFixed(2)
          : parseFloat(val.defTestPct || 0).toFixed(2);
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'C' &&
        val.paramTestIdVO.defTestTypeCd === 'STR'
      ) {
        b.CSTRtestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
        b.CSTRtestAmt = parseFloat(val.defTestAmt || 0).toFixed(2);
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'C' &&
        val.paramTestIdVO.defTestTypeCd === 'IDC'
      ) {
        b.CIDCtestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'I' &&
        val.paramTestIdVO.defTestTypeCd === 'UNP'
      ) {
        b.IUNPtestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
        b.IUNPtestPct = mul100
          ? parseFloat(val.defTestPct * 100 || 0).toFixed(2)
          : parseFloat(val.defTestPct || 0).toFixed(2);
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'I' &&
        val.paramTestIdVO.defTestTypeCd === 'RGR'
      ) {
        b.IRGRtestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
        b.IRGRtestPct = mul100
          ? parseFloat(val.defTestPct * 100 || 0).toFixed(2)
          : parseFloat(val.defTestPct || 0).toFixed(2);
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'I' &&
        val.paramTestIdVO.defTestTypeCd === 'RGP'
      ) {
        b.IRGPtestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
        b.IRGPtestPct = mul100
          ? parseFloat(val.defTestPct * 100 || 0).toFixed(2)
          : parseFloat(val.defTestPct || 0).toFixed(2);
      }
      if (
        val.paramTestIdVO.defTestGroupCd === 'I' &&
        val.paramTestIdVO.defTestTypeCd === 'RGL'
      ) {
        b.IRGLtestOnInd = val.defTestOnInd ? val.defTestOnInd : 0;
        b.IRGLtestPct = mul100
          ? parseFloat(val.defTestPct * 100 || 0).toFixed(2)
          : parseFloat(val.defTestPct || 0).toFixed(2);
      }
    });
  }
  return b;
};

// export const detailsInvoiceOverrideTabsValidation = (data) => {
//   let err = [];
//   let fld = {};
//   if (!data.shortDescr) {
//     err.push(Messages.SHORT_DESC_ERR);
//     fld.shtDescErr = true;
//   }
//   if (!data.rebateProgramCd) {
//     err.push(Messages.REBETE_PGM_ERR);
//     fld.rebatePgmErr = true;
//   }
//   if (
//     data.dbalModThreshold &&
//     !AppConstants.AMOUNT.test(data.dbalModThreshold)
//   ) {
//     err.push(Messages.DEC_THRES_ERR);
//     fld.dbalModThresholdErr = false;
//   }
//   if (!data.checkPayeeCd || data.checkPayeeCd === '-1') {
//     err.push(Messages.CHECK_PAY_ERR);
//     fld.checkPayErr = true;
//   }
//   if (!data.cms64AgencyName && data.planTypeCd === 'FD') {
//     err.push(Messages.CMS64_ERR);
//     fld.cms64Err = true;
//   }
//   if (
//     (!data.stateAbbrev || data.stateAbbrev === '-1') &&
//     data.planTypeCd === 'FD'
//   ) {
//     err.push(Messages.STATE_ERR);
//     fld.stateErr = true;
//   }
//   if (data.defEarliestQtrForDrugDtls === '') {
//     err.push(Messages.EARLIER_QTR_ERR);
//     fld.earlierQtrReqErr = true;
//   } else if (!checkQuarterValidation(data.defEarliestQtrForDrugDtls)) {
//     err.push(constantMessageData.VALIDATE_QUARTER_VALUE);
//     fld.earlierQtrQtrErr = true;
//   }
//   if (
//     (data.sendAllRetainedQtr !== '' &&
//       !AppConstants.NUMBER_REGEX.test(data.sendAllRetainedQtr)) ||
//     parseInt(data.sendAllRetainedQtr, 10) < 0 ||
//     parseInt(data.sendAllRetainedQtr, 10) > 4
//   ) {
//     err.push(Messages.SEND_ALL_RETAINED_QTR);
//     fld.sendAllRetainedQtrErr = true;
//   }
//   if (
//     data.rptBalanceDueThreshold !== '' &&
//     !AppConstants.NUMBER_REGEX.test(data.rptBalanceDueThreshold)
//   ) {
//     fld.rptBalanceDueThresholdErr = true;
//     err.push(Messages.REPORT_BALANCE_DUE_ERR);
//   }
//   if (
//     (data.invoiceMailThreshold !== '' &&
//       !AppConstants.NUMBER_REGEX.test(data.invoiceMailThreshold)) ||
//     parseInt(data.invoiceMailThreshold, 10) > 50
//   ) {
//     err.push(Messages.INVOICE_MAIL_ERR);
//     fld.invoiceMailThresholdErr = true;
//   }
//   if (
//     data.numOfDebitMfg !== '' &&
//     !AppConstants.NUMBER_REGEX.test(data.numOfDebitMfg)
//   ) {
//     err.push(Messages.DEBIT_MANUFACTURERS_ERR);
//     fld.numOfDebitMfgErr = true;
//   }
//   if (
//     data.numOfCreditMfg !== '' &&
//     !AppConstants.NUMBER_REGEX.test(data.numOfCreditMfg)
//   ) {
//     err.push(Messages.CREDIT_MANUFACTURERS_ERR);
//     fld.numOfCreditMfgErr = true;
//   }
//   if (
//     data.fiscalYearBeginDt &&
//     data.fiscalYearBeginDt !== '' &&
//     !validMMDDFormat(data.fiscalYearBeginDt)
//   ) {
//     err.push(Messages.FISCAL_YR_ERR);
//     fld.fiscalYrErr = true;
//   }
//   if (
//     (!data.invoiceHdrLine1 || data.invoiceHdrLine1 === '') &&
//     (!data.invoiceHdrLine2 || data.invoiceHdrLine2 === '') &&
//     (!data.invoiceHdrLine3 || data.invoiceHdrLine3 === '') &&
//     (!data.invoiceHdrLine4 || data.invoiceHdrLine4 === '')
//   ) {
//     err.push(Messages.INVOICE_HEADER_ERR);
//     fld.invoiceHdrLineErr = true;
//   }
//   if (
//     data.lastQtrWithoutClaims !== '' &&
//     !checkQuarterValidation(data.lastQtrWithoutClaims)
//   ) {
//     err.push(constantMessageData.VALIDATE_QUARTER_VALUE);
//     fld.lastQtrWithoutClaimsErr = true;
//   }
//   if (
//     data.firstSummaryRptQtr !== '' &&
//     !checkQuarterValidation(data.firstSummaryRptQtr)
//   ) {
//     err.push(constantMessageData.VALIDATE_QUARTER_VALUE);
//     fld.firstSummaryRptQtrErr = true;
//   }
//   if (
//     data.dramsInvoiceStartQtr !== '' &&
//     !checkQuarterValidation(data.dramsInvoiceStartQtr)
//   ) {
//     err.push(constantMessageData.VALIDATE_QUARTER_VALUE);
//     fld.dramsInvoiceStartQtrErr = true;
//   }
//   if (
//     data.nonCmsDrugInclCd === 'NEWZERO' ||
//     data.nonCmsDrugInclCd === 'NEWCALC'
//   ) {
//     if (data.nonCmsDrugInclQtrs === '') {
//       err.push(Messages.INCLUSION_QTR_ER);
//       fld.nonCmsDrugInclQtrsReqErr = true;
//     } else if (!AppConstants.NUMBER_REGEX.test(data.nonCmsDrugInclQtrs)) {
//       err.push(Messages.INCLUSION_QTR_VLD_ER);
//       fld.nonCmsDrugInclQtrsVldErr = true;
//     }
//   }
//   if (data.nonCmsDrugInclCd === '' || data.nonCmsDrugInclCd === '-1') {
//     err.push(Messages.INCLUSION_CODE_ERR);
//     fld.nonCmsDrugInclCdErr = true;
//   }
//   if (
//     data.oldInvoicePrefix &&
//     !AppConstants.NUMBER_REGEX.test(data.oldInvoicePrefix)
//   ) {
//     err.push(Messages.OLD_INVOICE_PREFIX_NUM_ERR);
//     fld.oldInvoicePrefixErr = true;
//   }
//   if (
//     data.frgvWoffThreshold &&
//     !AppConstants.NUMBER_REGEX.test(data.frgvWoffThreshold)
//   ) {
//     err.push(Messages.FORGIVE_THRESHOLD_NUM_ERR);
//     fld.frgvWoffThresholdErr = true;
//   }
//   return { err, fld };
// };

export const enrollTabValidation = (data, qtr) => {
  let err = [];
  let enrolldata = data.map((obj, ind) => {
    let disableFld =
      !obj.newFlag &&
      obj.qtr &&
      !obj.qtrErr &&
      qtr &&
      !compareQtrs(obj.qtr, qtr);
    let msg = qtrFieldValidation(
      obj.qtr,
      'ENROLL',
      ind + 1,
      data,
      'qtr',
      !disableFld ? true : false,
      qtr,
      obj
    );
    if (msg) {
      err.push(msg);
      obj.qtrErr = true;
      obj.qtrMsg = msg;
    }
    let enrollmentTimingCd =
      obj.enrollmentTimingCd == '-1'
        ? `${Messages.ENROLL_TIMING_ERR} ${ind + 1}`
        : null;
    if (enrollmentTimingCd) {
      err.push(enrollmentTimingCd);
      obj.timingcdErr = true;
      obj.timingcdMsg = msg;
    }
    return obj;
  });
  let rec = enrolldata;
  return { err, rec };
};

export const cmsReportingChk = (data, qtr) => {
  let err = [];
  let newdata = data.cmsReporting.map((obj, ind) => {
    let msg = qtrFieldValidation(
      obj.startQtr,
      'CMS_REPORT',
      ind + 1,
      data.cmsReporting,
      'startQtr',
      true,
      null,
      { data: obj }
    );
    if (msg) {
      err.push(msg);
      obj.startQtrErr = true;
      obj.startQtrMsg = msg;
    }
    msg = qtrFieldValidation(
      obj.endQtr,
      'CMS_REPORT',
      ind + 1,
      data.cmsReporting,
      'endQtr',
      true,
      qtr,
      { data: obj }
    );
    if (msg) {
      err.push(msg);
      obj.endQtrErr = true;
      obj.endQtrMsg = msg;
    }
    let cmsRptGroupNum = fieldValidationMsgs(
      'cmsRptGroupNum',
      'cmsrpt',
      obj.cmsRptGroupNum,
      ind + 1
    );
    if (cmsRptGroupNum) {
      err.push(cmsRptGroupNum);
      obj.cmsRptGroupNumErr = true;
      obj.cmsRptGroupNumMsg = cmsRptGroupNum;
    }
    let cmsRptGroupName = fieldValidationMsgs(
      'cmsRptGroupName',
      'cmsrpt',
      obj.cmsRptGroupName,
      ind + 1
    );
    if (cmsRptGroupName) {
      err.push(cmsRptGroupName);
      obj.cmsRptGroupNameErr = true;
      obj.cmsRptGroupNameMsg = cmsRptGroupName;
    }
    let cmsRptTitle = fieldValidationMsgs(
      'cmsRptTitle',
      'cmsrpt',
      obj.cmsRptTitle,
      ind + 1
    );
    if (cmsRptTitle) {
      err.push(cmsRptTitle);
      obj.cmsRptTitleErr = true;
      obj.cmsRptTitleMsg = cmsRptTitle;
    }
    return obj;
  });
  return { err, newdata };
};

export const cmsUtilizationChk = (data, qtr) => {
  let err = [];
  let newdata = data.cmsUtilization.map((obj, ind) => {
    let msg = qtrFieldValidation(
      obj.startQtr,
      'CMS_UTIL',
      ind + 1,
      data.cmsUtilization,
      'startQtr',
      true,
      null,
      { data: obj }
    );
    if (msg) {
      err.push(msg);
      obj.startQtrErr = true;
      obj.startQtrMsg = msg;
    }
    msg = qtrFieldValidation(
      obj.endQtr,
      'CMS_UTIL',
      ind + 1,
      data.cmsUtilization,
      'endQtr',
      true,
      qtr,
      { data: obj }
    );
    if (msg) {
      err.push(msg);
      obj.endQtrErr = true;
      obj.endQtrMsg = msg;
    }
    let cmsUtilGroupNum = fieldValidationMsgs(
      'cmsUtilGroupNum',
      'cmsutil',
      obj.cmsUtilGroupNum,
      ind + 1
    );
    if (cmsUtilGroupNum) {
      err.push(cmsUtilGroupNum);
      obj.cmsUtilGroupNumErr = true;
      obj.cmsUtilGroupNumMsg = cmsUtilGroupNum;
    }
    let cmsUtilGroupName = fieldValidationMsgs(
      'cmsUtilGroupName',
      'cmsutil',
      obj.cmsUtilGroupName,
      ind + 1
    );
    if (cmsUtilGroupName) {
      err.push(cmsUtilGroupName);
      obj.cmsUtilGroupNameErr = true;
      obj.cmsUtilGroupNameMsg = cmsUtilGroupName;
    }
    return obj;
  });
  return { err, newdata };
};

export const groupTabValidation = (data, qtr) => {
  let cmsReporting = cmsReportingChk(data, qtr);
  let cmsUtilization = cmsUtilizationChk(data, qtr);
  let err = [...cmsReporting.err, ...cmsUtilization.err];
  let rec = {
    cmsReporting: cmsReporting.newdata,
    cmsUtilization: cmsUtilization.newdata,
  };
  return { err, rec };
};

export const unitTypeTabValidation = (data) => {
  let err = [];
  let rec = data.map((val, ind) => {
    let error, merr;
    if (val.testOnInd) {
      if (val.testAmt === '' || val.testAmt === null)
        error = `${Messages.THRESHOLD_UNIT_ERR} ${ind + 1}`;
      else if (!/^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/.test(val.testAmt))
        error = `${Messages.THRESHOLD_UNIT_NUM_ERR} in Row ${ind + 1}`;
      if (error) {
        val.testAmtErr = true;
        val.testAmtMsg = error;
        err.push(error);
      }
      if (val.mailOrderMultiplier === '' || val.mailOrderMultiplier === null)
        merr = `${Messages.MAIL_ORDER_ERR} ${ind + 1}`;
      else if (
        !/^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/.test(val.mailOrderMultiplier)
      )
        merr = `${Messages.MAIL_ORDER_NUM_ERR} in Row ${ind + 1}`;
      if (merr) {
        val.mailOrderMultiplierErr = true;
        val.mailOrderMultiplierMsg = error;
        err.push(merr);
      }
    }
    return val;
  });
  return { err, rec };
};

export const auditTabValidation = (data) => {
  let err = [];
  let flderr = {};
  if (
    data.CUNAtestOnInd &&
    (data.CUNAtestAmt === '' || data.CUNAtestAmt === null)
  ) {
    flderr.CUNAtestAmtErr = true;
    err = [...err, `${Messages.AVG_PER_REQ_ERR}`];
  }
  if (
    data.CAEStestOnInd &&
    (data.CAEStestAmt === '' || data.CAEStestAmt === null)
  ) {
    flderr.CAEStestAmtErr = true;
    err = [...err, `${Messages.PER_SUB_ERR}`];
  }
  if (
    data.CSRAtestOnInd &&
    (data.CSRAtestAmt === '' || data.CSRAtestAmt === null)
  ) {
    flderr.CSRAtestAmtErr = true;
    err = [...err, `${Messages.PER_SUB_ERR}`];
  }
  if (
    data.CRLAtestOnInd &&
    (data.CRLAtestAmt === '' || data.CRLAtestAmt === null)
  ) {
    flderr.CRLAtestAmtErr = true;
    err = [...err, `${Messages.PER_ALLOW_ERR}`];
  }
  if (
    data.CSTRtestOnInd &&
    (data.CSTRtestAmt === '' || data.CSTRtestAmt === null)
  ) {
    flderr.CSTRtestAmtErr = true;
    err = [...err, `${Messages.THRES_AMT_ERR}`];
  }
  if (
    data.IUNPtestOnInd &&
    (data.IUNPtestPct === '' || data.IUNPtestPct === null)
  ) {
    flderr.IUNPtestPctErr = true;
    err = [...err, `${Messages.PER_PRIOR_ERR}`];
  }
  if (
    data.IRGRtestOnInd &&
    (data.IRGRtestPct === '' || data.IRGRtestPct === null)
  ) {
    flderr.IRGRtestPctErr = true;
    err = [...err, `${Messages.PER_REB_AMT_ERR}`];
  }
  if (
    data.IRGPtestOnInd &&
    (data.IRGPtestPct === '' || data.IRGPtestPct === null)
  ) {
    flderr.IRGPtestPctErr = true;
    err = [...err, `${Messages.PER_PRIOR_ERR}`];
  }
  if (
    data.IRGLtestOnInd &&
    (data.IRGLtestPct === '' || data.IRGLtestPct === null)
  ) {
    flderr.IRGLtestPctErr = true;
    err = [...err, `${Messages.PER_PRIOR_ERR}`];
  }
  return { err, flderr };
};

export const intCalcChk = (data) => {
  let err = [];
  let newdata = data.rpcParamVoIntShareIntCalList.map((obj, ind) => {
    let msg = qtrFieldValidation(
      obj.effectiveQtr,
      'INT_CALC',
      ind + 1,
      data.rpcParamVoIntShareIntCalList,
      'effectiveQtr'
    );
    if (msg) {
      err.push(msg);
      obj.effectiveQtrErr = true;
      obj.effectiveQtrMsg = msg;
    }
    let calcMethodCd = fieldValidationMsgs(
      'calcMethodCd',
      'intcalc',
      obj.calcMethodCd,
      ind + 1
    );
    if (calcMethodCd) {
      err.push(calcMethodCd);
      obj.calcMethodCdErr = true;
      obj.calcMethodCdMsg = calcMethodCd;
    }
    if (obj.calcMethodCd === 'F') {
      let calcFixedPct = fieldValidationMsgs(
        'calcFixedPct',
        'intcalc',
        obj.calcFixedPct,
        ind + 1
      );
      if (calcFixedPct) {
        err.push(calcFixedPct);
        obj.calcFixedPctErr = true;
        obj.calcFixedPctMsg = calcFixedPct;
      }
    }
    return obj;
  });
  return { err, newdata };
};

export const intFedaralChk = (data) => {
  let err = [];
  let newdata = data.rpcCalcPctVOIntShareFedaralList.map((obj, ind) => {
    let msg = qtrFieldValidation(
      obj.startQtr,
      'INT_FED',
      ind + 1,
      data.rpcCalcPctVOIntShareFedaralList,
      'startQtr'
    );
    if (msg) {
      err.push(msg);
      obj.startQtrErr = true;
      obj.startQtrMsg = msg;
    }
    let rpcParamValue = fieldValidationMsgs(
      'rpcParamValue',
      'intfed',
      obj.rpcParamValue,
      ind + 1,
      obj
    );
    if (rpcParamValue) {
      err.push(rpcParamValue);
      obj.rpcParamValueErr = true;
      obj.rpcParamValueMsg = rpcParamValue;
    }
    return obj;
  });
  return { err, newdata };
};

export const intFedFamilyChk = (data) => {
  let err = [];
  let newdata = data.rpcParamVoIntShareFedaralFamiliList.map((obj, ind) => {
    let msg = qtrFieldValidation(
      obj.startQtr,
      'INT_FED_FMLY',
      ind + 1,
      data.rpcParamVoIntShareFedaralFamiliList,
      'startQtr'
    );
    if (msg) {
      err.push(msg);
      obj.startQtrErr = true;
      obj.startQtrMsg = msg;
    }
    let rpcParamValue = fieldValidationMsgs(
      'rpcParamValue',
      'intfedfmly',
      obj.rpcParamValue,
      ind + 1,
      obj
    );
    if (rpcParamValue) {
      err.push(rpcParamValue);
      obj.rpcParamValueErr = true;
      obj.rpcParamValueMsg = rpcParamValue;
    }
    return obj;
  });
  return { err, newdata };
};

export const intTabValidation = (data, plan) => {
  let err = [];
  let rpcParamVoIntShareIntCalList = data.rpcParamVoIntShareIntCalList;
  if (plan !== 'FD') {
    let newdata = intCalcChk(data);
    err = [...err, ...newdata.err];
    rpcParamVoIntShareIntCalList = newdata.newdata;
  }
  let fedData = intFedaralChk(data);
  let rpcCalcPctVOIntShareFedaralList = fedData.newdata;
  err = [...err, ...fedData.err];
  let famlyData = intFedFamilyChk(data);
  let rpcParamVoIntShareFedaralFamiliList = famlyData.newdata;
  err = [...err, ...famlyData.err];
  let rec = {
    rpcParamVoIntShareIntCalList,
    rpcCalcPctVOIntShareFedaralList,
    rpcParamVoIntShareFedaralFamiliList,
  };
  return { err, rec };
};

export const uraSourceChk = (data) => {
  let err = [];
  let newdata = data.rpcUraSource.map((obj, ind) => {
    let msg = qtrFieldValidation(
      obj.startQtr,
      'URA_SOURCE',
      ind + 1,
      data.rpcUraSource,
      'startQtr'
    );
    if (msg) {
      err.push(msg);
      obj.startQtrErr = true;
      obj.startQtrMsg = msg;
    }
    return obj;
  });
  return { err, newdata };
};

export const uraCalcChk = (data, qtr, active_tab) => {
  let err = [];
  let newdata = data.rpcUraCal.map((obj, ind) => {
    let msg = qtrFieldValidation(
      obj.effectiveQtr,
      'URA_CALC',
      ind + 1,
      data.rpcUraCal,
      'effectiveQtr',
      true,
      qtr,
      obj,
      undefined,
      active_tab
    );
    if (msg) {
      err.push(msg);
      obj.effectiveQtrErr = true;
      obj.effectiveQtrMsg = msg;
    }
    let calcMethodCd = fieldValidationMsgs(
      'calcMethodCd',
      'calc',
      obj.calcMethodCd,
      ind + 1
    );
    if (calcMethodCd) {
      err.push(calcMethodCd);
      obj.calcMethodCdErr = true;
      obj.calcMethodCdMsg = calcMethodCd;
    }
    if (
      obj.calcMethodCd !== 'CMSPRI' &&
      obj.calcMethodCd !== 'CONTRACT' &&
      obj.calcMethodCd !== 'AMP' &&
      obj.calcMethodCd !== 'CMSAWP'
    ) {
      let calcGenericPct = fieldValidationMsgs(
        'calcGenericPct',
        'calc',
        obj.calcGenericPct,
        ind + 1
      );
      if (calcGenericPct) {
        err.push(calcGenericPct);
        obj.calcGenericPctErr = true;
        obj.calcGenericPctMsg = calcGenericPct;
      }
    }
    if (obj.calcMethodCd !== 'CMSPRI' && obj.calcMethodCd !== 'CONTRACT') {
      let calcFixedPct = fieldValidationMsgs(
        'calcFixedPct',
        'calc',
        obj.calcFixedPct,
        ind + 1
      );
      if (calcFixedPct) {
        err.push(calcFixedPct);
        obj.calcFixedPctErr = true;
        obj.calcFixedPctMsg = calcFixedPct;
      }
    }
    return obj;
  });
  return { err, newdata };
};

export const uraPayChk = (data) => {
  let err = [];
  let newdata = data.rpcUrPayment.map((obj, ind) => {
    let msg = qtrFieldValidation(
      obj.startQtr,
      'URA_PAY',
      ind + 1,
      data.rpcUrPayment,
      'startQtr'
    );
    if (msg) {
      err.push(msg);
      obj.startQtrErr = true;
      obj.startQtrMsg = msg;
    }
    return obj;
  });
  return { err, newdata };
};

export const uraTabValidation = (data, qtr, active_tab) => {
  let err = [];
  if (data.rpcUraSource.length === 0) err.push(Messages.URA_ERR);
  let srcdata = uraSourceChk(data);
  let rpcUraSource = srcdata.newdata;
  err = [...err, ...srcdata.err];
  let calcdata = uraCalcChk(data, qtr, active_tab);
  let rpcUraCal = calcdata.newdata;
  err = [...err, ...calcdata.err];
  let paydata = uraPayChk(data);
  let rpcUrPayment = paydata.newdata;
  err = [...err, ...paydata.err];
  if (
    rpcUraSource.filter((obj) => obj.rpcParamValue === 'CALC').length > 0 &&
    !rpcUraCal.length
  ) {
    err.push(Messages.URA_CALC_REQ);
  }
  let rec = { rpcUraSource, rpcUrPayment, rpcUraCal };
  return { err, rec };
};

export const qtrFieldValidation = (
  val,
  table,
  ind,
  data,
  fld,
  froze,
  cQtr,
  obj,
  lastUraSrcCalcQtr,
  active_tab
) => {
  var errmsg;
  if (val === '' || val === null) {
    if (table === 'URA_SOURCE') errmsg = `${Messages.URA_SRC_QTR_ERR} ${ind}.`;
    if (table === 'URA_CALC') errmsg = `${Messages.URA_CALC_QTR_ERR} ${ind}.`;
    if (table === 'URA_PAY') errmsg = `${Messages.URA_PAY_QTR_ERR} ${ind}.`;
    if (table === 'INT_CALC') errmsg = `${Messages.INT_CALC_QTR_ERR} ${ind}.`;
    if (table === 'INT_FED') errmsg = `${Messages.INT_FED_QTR_ERR} ${ind}.`;
    if (table === 'INT_FED_FMLY')
      errmsg = `${Messages.INT_FED_FMLY_QTR_ERR} ${ind}.`;
    if (table === 'CMS_UTIL' && fld === 'startQtr')
      errmsg = `${Messages.CMS_UTIL_SRT_QTR_ERR} ${ind}.`;
    // if (table === 'CMS_UTIL' && fld === 'endQtr')
    //   errmsg = `${Messages.CMS_UTIL_END_QTR_ERR} ${ind}.`;
    // if (table === 'CMS_REPORT' && fld === 'endQtr')
    //   errmsg = `${Messages.CMS_RPT_END_QTR_ERR} ${ind}.`;
    if (table === 'CMS_REPORT' && fld === 'startQtr')
      errmsg = `${Messages.CMS_RPT_SRT_QTR_ERR} ${ind}.`;
    if (table === 'ENROLL') errmsg = `${Messages.QTR_ENROLL_ERR} ${ind}`;
  } else if (!checkQuarterValidation(val)) {
    if (table === 'URA_SOURCE')
      errmsg = `${Messages.INVALID_QTR_ERR} for URA Source in Row ${ind}.`;
    if (table === 'URA_CALC')
      errmsg = `${Messages.INVALID_QTR_ERR} for URA Calculation in Row ${ind}.`;
    if (table === 'URA_PAY')
      errmsg = `${Messages.INVALID_QTR_ERR} for Update URA from Payments in Row ${ind}.`;
    if (table === 'INT_CALC')
      errmsg = `${Messages.INVALID_QTR_ERR} for Interest Calculation in Row ${ind}.`;
    if (table === 'INT_FED')
      errmsg = `${Messages.INVALID_QTR_ERR} for Federal % in Row ${ind}.`;
    if (table === 'INT_FED_FMLY')
      errmsg = `${Messages.INVALID_QTR_ERR} for Federal Family Planning % in Row ${ind}.`;
    if (table === 'CMS_UTIL' && fld === 'startQtr')
      errmsg = `${Messages.INVALID_QTR_ERR} for CMS Utilisation Start Quarter in Row ${ind}.`;
    if (table === 'CMS_UTIL' && fld === 'endQtr')
      errmsg = `${Messages.INVALID_QTR_ERR} for CMS Utilisation End Quarter in Row ${ind}.`;
    if (table === 'CMS_REPORT' && fld === 'startQtr')
      errmsg = `${Messages.INVALID_QTR_ERR} for CMS Report Start Quarter in Row ${ind}.`;
    if (table === 'CMS_REPORT' && fld === 'endQtr')
      errmsg = `${Messages.INVALID_QTR_ERR} for CMS Report End Quarter in Row ${ind}.`;
    if (table === 'ENROLL')
      errmsg = `${Messages.INVALID_QTR_ERR} for Enrollment Quarter in Row ${ind}.`;
  } else {
    let qtr = data.filter((obj) => obj[fld] === val);
    if (qtr.length > 1) {
      if (table === 'URA_SOURCE')
        errmsg = `${Messages.UNIQ_URA_SRC} in Row ${ind}.`;
      if (table === 'URA_CALC')
        errmsg = `${Messages.UNIQ_URA_CALC} in Row ${ind}.`;
      if (table === 'URA_PAY')
        errmsg = `${Messages.UNIQ_URA_PAY} in Row ${ind}.`;
      if (table === 'CMS_UTIL')
        errmsg = `${Messages.UNIQ_CMS_UTIL} in Row ${ind}.`;
      if (table === 'CMS_REPORT')
        errmsg = `${Messages.UNIQ_CMS_RPT} in Row ${ind}.`;
      if (table === 'INT_CALC')
        errmsg = `${Messages.UNIQ_INT_CALC} in Row ${ind}.`;
      if (table === 'INT_FED')
        errmsg = `${Messages.UNIQ_INT_FED} in Row ${ind}.`;
      if (table === 'INT_FED_FMLY')
        errmsg = `${Messages.UNIQ_INT_FED_FAM} in Row ${ind}.`;
      if (table === 'ENROLL') errmsg = `${Messages.UNIQ_ENROLL} in Row ${ind}.`;
    }
  }
  // if (
  //   (table === 'INT_FED' || table === 'INT_FED_FMLY') &&
  //   !errmsg
  //   // fld === 'rpcParamValue' &&
  //   // extraCondition?.startQtr
  // ) {
  //   const currObj = data.filter((obj) => obj.startQtr === val);
  //   const startQtrDate = convertQuaterToDate(val);
  //   if (new Date(startQtrDate) < new Date() && currObj?.[0]?.newFlag) {
  //     if (table === 'INT_FED')
  //       errmsg = `${Messages.INT_FED_PAST_ERR} for Federal % in Row ${ind}.`;
  //     if (table === 'INT_FED_FMLY')
  //       errmsg = `${Messages.INT_FED_PAST_ERR} for Federal Family Planning % in Row ${ind}.`;
  //   }
  // }
  if (froze && !errmsg) {
    if (fld === 'effectiveQtr') {
      if (table === 'URA_CALC' && active_tab === 'three') {
        if (
          lastUraSrcCalcQtr &&
          !compareQtrs(val, lastUraSrcCalcQtr) &&
          val.toUpperCase() !== lastUraSrcCalcQtr.toUpperCase()
        ) {
          errmsg = `${Messages.URA_CALC_EFFECTIVE_QTR} in Row ${ind}.`;
        }
        if (
          !errmsg &&
          cQtr &&
          !compareQtrs(val, cQtr) &&
          val.toUpperCase() !== cQtr.toUpperCase()
        ) {
          errmsg = `${Messages.FROZEN_QTR_ERR} (${cQtr} or later) in Row ${ind}.`;
        }
      }
      // if (!compareQtrs(val, cQtr)) {
      //   if (table === 'URA_CALC') errmsg = Messages.URA_CALC_EFFECTIVE_QTR;
      //   else
      // errmsg = `${Messages.FROZEN_QTR_ERR} (${cQtr} or later) in Row ${ind}.`;
      // }
    }
    if (fld === 'startQtr') {
      if (
        obj.data.endQtr &&
        val !== obj.data.endQtr &&
        compareQtrs(val, obj.data.endQtr)
      ) {
        if (table === 'CMS_REPORT')
          errmsg = `${Messages.END_QTR_ERR} for CMS Reporting in Row ${ind}.`;
        if (table === 'CMS_UTIL')
          errmsg = `${Messages.END_QTR_ERR} for CMS Utilization in Row ${ind}.`;
      }
    }
    if (fld === 'endQtr' && val) {
      if (table === 'CMS_REPORT') {
        if (
          obj.data.startQtr &&
          val !== obj.data.startQtr &&
          !compareQtrs(val, obj.data.startQtr)
        )
          errmsg = `${Messages.END_QTR_ERR} for CMS Reporting in Row ${ind}.`;
        else if (cQtr && !compareQtrs(val, cQtr) && cQtr !== val)
          errmsg = `${Messages.CMS_FREEZE_RPT_ERR}${cQtr} in Row ${ind}.`;
      }
      if (table === 'CMS_UTIL') {
        if (
          obj.data.startQtr &&
          val !== obj.data.startQtr &&
          !compareQtrs(val, obj.data.startQtr)
        )
          errmsg = `${Messages.END_QTR_ERR} for CMS Utilization in Row ${ind}.`;
        else if (cQtr && !compareQtrs(val, cQtr) && cQtr !== val)
          errmsg = `${Messages.CMS_FREEZE_UTIL_ERR}${cQtr} in Row ${ind}.`;
      }
    }
    if (table === 'ENROLL' && froze && !compareQtrs(val, froze))
      errmsg = `${Messages.ENROLL_LESS_QTR_ERR} (${froze}) in Row ${ind}.`;
  }
  // Overlap validations fro group tab
  if (!errmsg) {
    if (fld === 'startQtr' && table === 'CMS_REPORT' && data.length > 1) {
      if (isOverlapQtr(data, ind, val)) {
        errmsg = `${Messages.START_QTR_OVERLAP_ERR} for CMS Reporting in Row ${ind}.`;
      }
    }
    if (fld === 'endQtr' && table === 'CMS_REPORT' && data.length > 1) {
      if (isOverlapQtr(data, ind, val)) {
        errmsg = `${Messages.END_QTR_OVERLAP_ERR} for CMS Reporting in Row ${ind}.`;
      }
    }

    if (fld === 'startQtr' && table === 'CMS_UTIL' && data.length > 1) {
      if (isOverlapQtr(data, ind, val)) {
        errmsg = `Start Quarter overlaps for CMS Utilization in Row ${ind}.`;
        errmsg = `${Messages.START_QTR_OVERLAP_ERR} for CMS Utilization in Row ${ind}.`;
      }
    }
    if (fld === 'endQtr' && table === 'CMS_UTIL' && data.length > 1) {
      if (isOverlapQtr(data, ind, val)) {
        errmsg = `${Messages.END_QTR_OVERLAP_ERR} for CMS Utilization in Row ${ind}.`;
      }
    }
    if (fld === 'startQtr' && table === 'URA_SOURCE' && data.length > 1) {
      if (isOverlapQtr(data, ind, val)) {
        errmsg = `Start Quarter overlaps for URA Source in Row ${ind}.`;
        errmsg = `${Messages.START_QTR_OVERLAP_ERR} for URA Source in Row ${ind}.`;
      }
    }
  }
  return errmsg;
};

export const qtrHandler = (
  val,
  data,
  blur,
  record,
  error,
  table,
  fld,
  frozen,
  cQtr,
  lastUraSrcCalcQtr,
  active_tab
) => {
  let tabdata = { ...record };
  let gridData, key;
  if (table === 'src') {
    gridData = [...record.rpcUraSource];
    key = 'URA_SOURCE';
  }
  if (table === 'calc') {
    gridData = [...record.rpcUraCal];
    key = 'URA_CALC';
  }
  if (table === 'pay') {
    gridData = [...record.rpcUrPayment];
    key = 'URA_PAY';
  }
  if (table === 'intcalc') {
    gridData = [...record.rpcParamVoIntShareIntCalList];
    key = 'INT_CALC';
  }
  if (table === 'intfed') {
    gridData = [...record.rpcCalcPctVOIntShareFedaralList];
    key = 'INT_FED';
  }
  if (table === 'intfedfmly') {
    gridData = [...record.rpcParamVoIntShareFedaralFamiliList];
    key = 'INT_FED_FMLY';
  }
  if (table === 'cmsutil') {
    gridData = [...record.cmsUtilization];
    key = 'CMS_UTIL';
  }
  if (table === 'cmsrpt') {
    gridData = [...record.cmsReporting];
    key = 'CMS_REPORT';
  }
  if (table === 'roll') {
    gridData = [...record];
    key = 'ENROLL';
  }
  let err = [...error];
  let indx = data.node.rowIndex + 1;
  let errmsg = qtrFieldValidation(
    val,
    key,
    indx,
    gridData,
    fld,
    frozen,
    cQtr,
    data,
    lastUraSrcCalcQtr,
    key === 'URA_CALC' ? active_tab : undefined
  );
  let newdata = gridData.map((obj, ind) => {
    if (indx - 1 === ind) {
      if (blur)
        if (errmsg) {
          obj[`${fld}Err`] = true;
          let oldErr = [obj[`${fld}Msg`]];
          err = removeErr(err, oldErr);
          obj[`${fld}Msg`] = errmsg;
          err = [...err, errmsg];
        } else {
          obj[`${fld}Err`] = false;
          let qtrval = gridData.map((obj) => obj[fld]);
          let rmv = [obj[`${fld}Msg`]];
          if (qtrval.length === _.uniq(qtrval).length) {
            gridData.forEach((val) => {
              if (
                val[`${fld}Msg`] &&
                val[`${fld}Msg`].indexOf(Messages.UNIQ_URA_SRC) !== -1
              )
                rmv.push(val[`${fld}Err`]);
            });
          }
          obj[`${fld}Msg`] = '';
          // if (frozen) {
          //   let msg = `${Messages.FROZEN_QTR_ERR} (${cQtr} or later)`;
          //   if (!compareQtrs(val, cQtr)) {
          //     err = [...new Set([...err, msg])];
          //     obj.qtrMsg = msg;
          //     obj.qtrErr = true;
          //   } else {
          //     rmv.push(msg);
          //   }
          // }
          err = removeErr(err, rmv);
        }
      obj[fld] = val.toUpperCase();
      if (blur) obj[fld] = autoFormateDate(val);
    }
    return obj;
  });
  if (table === 'src') tabdata.rpcUraSource = newdata;
  if (table === 'calc') tabdata.rpcUraCal = newdata;
  if (table === 'pay') tabdata.rpcUrPayment = newdata;
  if (table === 'intcalc') tabdata.rpcParamVoIntShareIntCalList = newdata;
  if (table === 'intfed') tabdata.rpcCalcPctVOIntShareFedaralList = newdata;
  if (table === 'intfedfmly')
    tabdata.rpcParamVoIntShareFedaralFamiliList = newdata;
  if (table === 'cmsutil') tabdata.cmsUtilization = newdata;
  if (table === 'cmsrpt') tabdata.cmsReporting = newdata;
  if (table === 'roll') tabdata = newdata;
  return { tabdata, err };
};

export const deleteTableRecord = (table, gridData) => {
  let tabledata = { ...gridData };
  let err = [];
  let deleted = [];
  let deletedOld = [];
  if (table === 'src') {
    let updated = tabledata.rpcUraSource.filter((ob) => !ob.delete);
    deleted = tabledata.rpcUraSource.filter((o) => o.delete);
    deletedOld = deleted.filter((o) => !o.newFlag);
    tabledata.rpcUraSource = updated;
    err = deleted.map((o) => o.startQtrMsg);
  }
  if (table === 'calc') {
    let updated = tabledata.rpcUraCal.filter((ob) => !ob.delete);
    deleted = tabledata.rpcUraCal.filter((o) => o.delete);
    deletedOld = deleted.filter((o) => !o.newFlag);
    tabledata.rpcUraCal = updated;
    err = [
      ...deleted.map((o) => o.effectiveQtrMsg),
      ...deleted.map((o) => o.calcMethodCdMsg),
      ...deleted.map((o) => o.calcGenericPctMsg),
      ...deleted.map((o) => o.calcFixedPctMsg),
    ];
  }
  if (table === 'pay') {
    let updated = tabledata.rpcUrPayment.filter((ob) => !ob.delete);
    deleted = tabledata.rpcUrPayment.filter((o) => o.delete);
    deletedOld = deleted.filter((o) => !o.newFlag);
    tabledata.rpcUrPayment = updated;
    err = deleted.map((o) => o.startQtrMsg);
  }
  if (table === 'intcalc') {
    let updated = tabledata.rpcParamVoIntShareIntCalList.filter(
      (ob) => !ob.delete
    );
    deleted = tabledata.rpcParamVoIntShareIntCalList.filter((o) => o.delete);
    deletedOld = deleted.filter((o) => !o.newFlag);
    tabledata.rpcParamVoIntShareIntCalList = updated;
    err = [
      ...deleted.map((o) => o.effectiveQtrMsg),
      ...deleted.map((o) => o.calcMethodCdMsg),
      ...deleted.map((o) => o.calcFixedPctMsg),
    ];
  }
  if (table === 'intfed') {
    let updated = tabledata.rpcCalcPctVOIntShareFedaralList.filter(
      (ob) => !ob.delete
    );
    deleted = tabledata.rpcCalcPctVOIntShareFedaralList.filter((o) => o.delete);
    deletedOld = deleted.filter((o) => !o.newFlag);
    tabledata.rpcCalcPctVOIntShareFedaralList = updated;
    err = [
      ...deleted.map((o) => o.startQtrMsg),
      ...deleted.map((o) => o.rpcParamValueMsg),
    ];
  }
  if (table === 'intfedfmly') {
    let updated = tabledata.rpcParamVoIntShareFedaralFamiliList.filter(
      (ob) => !ob.delete
    );
    deleted = tabledata.rpcParamVoIntShareFedaralFamiliList.filter(
      (o) => o.delete
    );
    deletedOld = deleted.filter((o) => !o.newFlag);
    tabledata.rpcParamVoIntShareFedaralFamiliList = updated;
    err = [
      ...deleted.map((o) => o.startQtrMsg),
      ...deleted.map((o) => o.rpcParamValueMsg),
    ];
  }
  if (table === 'cmsrpt') {
    let updated = tabledata.cmsReporting.filter((ob) => !ob.delete);
    deleted = tabledata.cmsReporting.filter((o) => o.delete);
    deletedOld = deleted.filter((o) => !o.newFlag);
    tabledata.cmsReporting = updated;
    err = [
      ...deleted.map((o) => o.startQtrMsg),
      ...deleted.map((o) => o.endQtrMsg),
      ...deleted.map((o) => o.cmsRptGroupNumMsg),
      ...deleted.map((o) => o.cmsRptGroupNameMsg),
      ...deleted.map((o) => o.cmsRptTitleMsg),
    ];
  }
  if (table === 'cmsutil') {
    let updated = tabledata.cmsUtilization.filter((ob) => !ob.delete);
    deleted = tabledata.cmsUtilization.filter((o) => o.delete);
    deletedOld = deleted.filter((o) => !o.newFlag);
    tabledata.cmsUtilization = updated;
    err = [
      ...deleted.map((o) => o.startQtrMsg),
      ...deleted.map((o) => o.endQtrMsg),
      ...deleted.map((o) => o.cmsUtilGroupNumMsg),
      ...deleted.map((o) => o.cmsUtilGroupNameMsg),
    ];
  }
  if (table === 'roll') {
    tabledata = [...gridData];
    let updated = tabledata.filter((ob) => !ob.delete);
    deleted = tabledata.filter((o) => o.delete);
    deletedOld = deleted.filter((o) => !o.newFlag);
    tabledata = updated;
    err = [
      ...deleted.map((o) => o.qtrMsg),
      ...deleted.map((o) => o.timingcdMsg),
    ];
  }
  return { err, deletedOld, tabledata };
};

export const addTableRecord = (table, gridData, code, plan, logInUser) => {
  let tabledata = { ...gridData };
  let adddata;
  if (table === 'src')
    adddata = {
      ...Messages.ADD_URA_SRC_DATA,
      startQtr: plan === 'FD' ? '1Q1991' : '',
      rpcParamValue: plan === 'FD' || plan === 'ST' ? 'CMS' : 'CALC',
    };
  if (table === 'calc') adddata = { ...Messages.ADD_URA_CALC_DATA };
  if (table === 'pay') adddata = { ...Messages.ADD_URA_PAY_DATA };

  if (table === 'intcalc') {
    if (tabledata?.rpcParamVoIntShareIntCalList.length === 0) {
      adddata = {
        ...Messages.ADD_INT_CALC_DATA,
        effectiveQtr: plan === 'FD' ? '1Q1991' : '',
        calcMethodCd: plan === 'FD' ? 'T' : '',
      };
    } else {
      adddata = { ...Messages.ADD_INT_CALC_DATA };
    }
  }

  if (table === 'intfed') adddata = { ...Messages.ADD_FED_DATA };
  if (table === 'intfedfmly') adddata = { ...Messages.ADD_FED_FMLY_DATA };
  if (table === 'cmsrpt') adddata = { ...Messages.ADD_CMS_RPT_DATA };
  if (table === 'cmsutil') adddata = { ...Messages.ADD_CMS_UTIL_DATA };
  if (table === 'roll') adddata = { ...Messages.ADD_ENROLL_DATA };
  adddata.lastUpdateUserId = logInUser;
  adddata.rebateProgramCd = code;
  adddata.id = uuidv4();
  if (table === 'src') tabledata.rpcUraSource.push(adddata);
  if (table === 'calc') tabledata.rpcUraCal.push(adddata);
  if (table === 'pay') tabledata.rpcUrPayment.push(adddata);
  if (table === 'intcalc') tabledata.rpcParamVoIntShareIntCalList.push(adddata);
  if (table === 'intfed')
    tabledata.rpcCalcPctVOIntShareFedaralList.push(adddata);
  if (table === 'intfedfmly')
    tabledata.rpcParamVoIntShareFedaralFamiliList.push(adddata);
  if (table === 'cmsrpt') tabledata.cmsReporting.push(adddata);
  if (table === 'cmsutil') tabledata.cmsUtilization.push(adddata);
  if (table === 'roll') tabledata = [...gridData, adddata];
  return tabledata;
};

export const mergeSysDefOverrides = (obj, val, sysVal, defVal) => {
  let values = { ...obj };
  values.invoiceMailThreshold = val
    ? sysVal?.defInvoiceMailThreshold
    : defVal?.invoiceMailThreshold;
  values.reimbUnderThresholdMult = val
    ? sysVal?.defReimbUnderThresholdMult
    : defVal?.reimbUnderThresholdMult;
  values.showDisputeOnInvInd = val
    ? sysVal?.defShowDisputeOnInvInd
    : defVal?.showDisputeOnInvInd;
  values.unitConvChangesDataInd = val
    ? sysVal?.defUnitConvChangesDataInd
    : defVal?.unitConvChangesDataInd;
  values.autoUnderThresholdInd = val
    ? sysVal?.defAutoUnderThresholdInd
    : defVal?.autoUnderThresholdInd;
  values.sendAllRetainedQtr = val
    ? sysVal?.defSendAllRetainedQtr
    : defVal?.sendAllRetainedQtr;
  values.forgiveReqCommentInd = val
    ? sysVal?.defForgiveReqCommentInd
    : defVal?.forgiveReqCommentInd;
  values.nonZeroBilledUnitsInd = val
    ? sysVal?.defNonZeroBilledUnitsInd
    : defVal?.nonZeroBilledUnitsInd;
  return values;
};

export const auditTabDataCons = (obj) => {
  let b = {};
  obj.forEach((val) => {
    if (val.testGroupCd === 'C' && val.testTypeCd === 'UNA') {
      b.CUNAtestOnInd = val.testOnInd;
      b.CUNAtestAmt = parseFloat(val.testPct || 0).toFixed(2);
    }
    if (val.testGroupCd === 'C' && val.testTypeCd === 'RES') {
      b.CREStestOnInd = val.testOnInd;
    }
    if (val.testGroupCd === 'C' && val.testTypeCd === 'AES') {
      b.CAEStestOnInd = val.testOnInd;
      b.CAEStestAmt = parseFloat(val.testPct || 0).toFixed(2);
    }
    if (val.testGroupCd === 'C' && val.testTypeCd === 'SRA') {
      b.CSRAtestOnInd = val.testOnInd;
      b.CSRAtestAmt = parseFloat(val.testPct || 0).toFixed(2);
    }
    if (val.testGroupCd === 'C' && val.testTypeCd === 'RLA') {
      b.CRLAtestOnInd = val.testOnInd;
      b.CRLAtestAmt = parseFloat(val.testPct || 0).toFixed(2);
    }
    if (val.testGroupCd === 'C' && val.testTypeCd === 'STR') {
      b.CSTRtestOnInd = val.testOnInd;
      b.CSTRtestAmt = parseFloat(val.testAmt || 0).toFixed(2);
    }
    if (val.testGroupCd === 'C' && val.testTypeCd === 'IDC') {
      b.CIDCtestOnInd = val.testOnInd;
    }
    if (val.testGroupCd === 'I' && val.testTypeCd === 'UNP') {
      b.IUNPtestOnInd = val.testOnInd;
      b.IUNPtestPct = parseFloat(val.testPct || 0).toFixed(2);
    }
    if (val.testGroupCd === 'I' && val.testTypeCd === 'RGR') {
      b.IRGRtestOnInd = val.testOnInd;
      b.IRGRtestPct = parseFloat(val.testPct || 0).toFixed(2);
    }
    if (val.testGroupCd === 'I' && val.testTypeCd === 'RGP') {
      b.IRGPtestOnInd = val.testOnInd;
      b.IRGPtestPct = parseFloat(val.testPct || 0).toFixed(2);
    }
    if (val.testGroupCd === 'I' && val.testTypeCd === 'RGL') {
      b.IRGLtestOnInd = val.testOnInd;
      b.IRGLtestPct = parseFloat(val.testPct || 0).toFixed(2);
    }
  });
  return b;
};

export const fieldValidationMsgs = (fld, table, val, ind, extraCondition) => {
  let errmsg;
  // if (
  //   (table === 'intfed' || table === 'intfedfmly') &&
  //   fld === 'rpcParamValue' &&
  //   extraCondition?.startQtr
  // ) {
  //   const startQtrDate = convertQuaterToDate(extraCondition.startQtr);
  //   if (new Date(startQtrDate) < new Date()) {
  //     if (table === 'intfed')
  //       errmsg = `${Messages.INT_FED_PAST_ERR} for Federal % in Row ${ind}.`;
  //     if (table === 'intfedfmly')
  //       errmsg = `${Messages.INT_FED_PAST_ERR} for Federal Family Planning % in Row ${ind}.`;
  //   }
  // }
  if (!errmsg && (val === '' || val === null)) {
    if (table === 'cmsrpt' && fld === 'cmsRptGroupNum')
      errmsg = `${Messages.GRP_NUM_ERR} for CMS Reporting in Row ${ind}.`;
    if (table === 'cmsrpt' && fld === 'cmsRptGroupName')
      errmsg = `${Messages.GROUP_NAME_ERR} for CMS Reporting in Row ${ind}.`;
    if (table === 'cmsrpt' && fld === 'cmsRptTitle')
      errmsg = `${Messages.REPORT_TTL_ERR} for CMS Reporting in Row ${ind}.`;
    if (table === 'cmsutil' && fld === 'cmsUtilGroupNum')
      errmsg = `${Messages.GRP_NUM_ERR} for CMS Utilization in Row ${ind}.`;
    if (table === 'cmsutil' && fld === 'cmsUtilGroupName')
      errmsg = `${Messages.GROUP_NAME_ERR} for CMS Utilization in Row ${ind}.`;
    if (table === 'intfedfmly' && fld === 'rpcParamValue')
      errmsg = `${Messages.PERCENT_REQ_ERR} for Federal Family Planning % in Row ${ind}.`;
    if (table === 'intfed' && fld === 'rpcParamValue')
      errmsg = `${Messages.PERCENT_REQ_ERR} for Federal % in Row ${ind}.`;
    if (table === 'intcalc' && fld === 'calcFixedPct')
      errmsg = `${Messages.PERCENT_REQ_ERR} for Interest Calculation in Row ${ind}.`;
    if (table === 'calc' && fld === 'calcFixedPct')
      errmsg = `Brand ${Messages.PERCENT_REQ_ERR} for URA Calculation in Row ${ind}.`;
    if (table === 'calc' && fld === 'calcGenericPct')
      errmsg = `Generic ${Messages.PERCENT_REQ_ERR} for URA Calculation in Row ${ind}.`;
  }
  if (!errmsg && val && !AppConstants.AMOUNT.test(val)) {
    if (table === 'cmsrpt' && fld === 'cmsRptGroupNum')
      errmsg = `${Messages.GRP_NUM_NUMERIC_ERR} for CMS Reporting in Row ${ind}.`;
    if (table === 'cmsutil' && fld === 'cmsUtilGroupNum')
      errmsg = `${Messages.GRP_NUM_NUMERIC_ERR} for CMS Utilization in Row ${ind}.`;
    if (table === 'intfedfmly' && fld === 'rpcParamValue')
      errmsg = `${Messages.PERCENT_NUM_ERR} for Federal Family Planning % in Row ${ind}.`;
    if (table === 'intfed' && fld === 'rpcParamValue')
      errmsg = `${Messages.PERCENT_NUM_ERR} for Federal % in Row ${ind}.`;
    if (table === 'intcalc' && fld === 'calcFixedPct')
      errmsg = `${Messages.PERCENT_NUM_ERR} for Interest Calculation % in Row ${ind}.`;
  }

  if (!errmsg && val && !AppConstants.BAL_PERCENT_REGEX.test(val)) {
    if (table === 'calc' && fld === 'calcFixedPct')
      errmsg = `Brand ${Messages.PERCENT_NUM_ERR} for URA Calculation in Row ${ind}.`;
    if (table === 'calc' && fld === 'calcGenericPct')
      errmsg = `Generic ${Messages.PERCENT_NUM_ERR} for URA Calculation in Row ${ind}.`;
  }

  if (val == '-1') {
    if (table === 'intcalc' && fld === 'calcMethodCd')
      errmsg = `${Messages.CALC_MTHD_ERR} for Interest Calculation in Row ${ind}.`;
    if (table === 'calc' && fld === 'calcMethodCd')
      errmsg = `${Messages.CALC_MTHD_ERR} for URA Calculation in Row ${ind}.`;
    // if (table==='roll' && fld === 'enrollmentTimingCd')
    //   errmsg =
  }
  return errmsg;
};

export const tableFldBlurAction = (fld, tbl, val, indx, data, chk, er = []) => {
  let err = [...er];
  let newdata = data?.map((obj, ind) => {
    if (indx === ind) {
      obj[fld] = val;
      let msg = fieldValidationMsgs(fld, tbl, val, indx + 1, obj);
      if (chk) {
        let old = obj[`${fld}Msg`];
        err = removeErr(err, [old]);
        if (msg) {
          obj[`${fld}Err`] = true;
          obj[`${fld}Msg`] = msg;
          err = [...new Set([...err, msg])];
        } else {
          obj[`${fld}Err`] = false;
          obj[`${fld}Msg`] = '';
        }
      }
    }
    obj.edited = true;
    return obj;
  });
  return { newdata, err };
};

export const getAuditPayload = (data, code, logInUser) => {
  let rpcParamTestVOList = [];
  const typeCd = [
    'AES',
    'IDC',
    'RES',
    'RLA',
    'SRA',
    'STR',
    'UNA',
    'RGL',
    'RGP',
    'RGR',
    'UNP',
  ];
  typeCd.forEach((val) => {
    let obj = {
      testOnInd: 0,
      testPct: 0,
      testAmt: 0,
      mailOrderMultiplier: null,
      lastUpdateUserId: logInUser,
    };
    obj.rpcParamTestPKVO = {
      rebateProgramCd: code,
      testGroupCd:
        val === 'RGL' || val === 'RGP' || val === 'RGR' || val === 'UNP'
          ? 'I'
          : 'C',
      testTypeCd: val,
      testUnitTypeCd: ' ',
    };
    if (val === 'AES') {
      obj.testPct = data.CAEStestAmt;
      obj.testOnInd = data.CAEStestOnInd;
    }
    if (val === 'IDC') obj.testOnInd = data.CIDCtestOnInd;
    if (val === 'RES') obj.testOnInd = data.CREStestOnInd;
    if (val === 'RLA') {
      obj.testPct = data.CRLAtestAmt;
      obj.testOnInd = data.CRLAtestOnInd;
    }
    if (val === 'SRA') {
      obj.testPct = data.CSRAtestAmt;
      obj.testOnInd = data.CSRAtestOnInd;
    }
    if (val === 'STR') {
      obj.testAmt = data.CSTRtestAmt;
      obj.testOnInd = data.CSTRtestOnInd;
    }
    if (val === 'UNA') {
      obj.testPct = data.CUNAtestAmt;
      obj.testOnInd = data.CUNAtestOnInd;
    }
    if (val === 'RGL') {
      obj.testPct = data.IRGLtestPct;
      obj.testOnInd = data.IRGLtestOnInd;
    }
    if (val === 'RGP') {
      obj.testPct = data.IRGPtestPct;
      obj.testOnInd = data.IRGPtestOnInd;
    }
    if (val === 'RGR') {
      obj.testPct = data.IRGRtestPct;
      obj.testOnInd = data.IRGRtestOnInd;
    }
    if (val === 'UNP') {
      obj.testPct = data.IUNPtestPct;
      obj.testOnInd = data.IUNPtestOnInd;
    }
    rpcParamTestVOList.push(obj);
  });
  return { rpcParamTestVOList };
};

export const getUnitAuditPayload = (data, code, logInUser) => {
  let rpcParamTestUnitAuditVOList = [];
  let key = ['EA', 'GM', 'ML', 'SUP', 'TAB', 'TDP', 'AHF', 'CAP'];
  key.forEach((val) => {
    let row = data.filter((obj) => obj.testUnitTypeCd === val);
    let obj = {
      rpcParamTestPKVO: {
        rebateProgramCd: code,
        testGroupCd: 'C',
        testTypeCd: 'UNT',
        testUnitTypeCd: val,
      },
      testOnInd: row?.[0]?.testOnInd,
      testPct: row?.[0]?.testPct,
      testAmt: row?.[0]?.testAmt,
      mailOrderMultiplier: row?.[0]?.mailOrderMultiplier,
      lastUpdateUserId: logInUser,
    };
    rpcParamTestUnitAuditVOList.push(obj);
  });
  return { rpcParamTestUnitAuditVOList };
};
